class PredictiveSearchNew extends SearchForm {
    constructor() {
      super();
  
      this.cachedMap = new Map();
      this.cachedResults = {};
      this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
      this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
      this.isOpen = false;
      this.abortController = new AbortController();
      this.searchTerm = '';
      this.searchContent = this.querySelector('.search__content');
      this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';
  
      this.setupEventListeners();
      
    }
  
    setupEventListeners() {
      if (this.input && this.input.form) {
        this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      }
      if (this.input) {
        this.input.addEventListener('focus', this.onFocus.bind(this));
        this.input.addEventListener('input', debounce(this.onChange.bind(this), 300));
        this.input.addEventListener('keyup', (e) => {
          if (e.key.length === 1 || e.key === 'Backspace' || e.key === 'Delete') {
            this.onChange();
          } else {
            this.onKeyup(e);
          }
        });
      }
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }
  
    onFormSubmit(event) {
      const query = this.getQuery();
      if (query.length > 0) {
        const normalizedValue = this.normalizeGreekText(query);
        if (query !== normalizedValue) {
          this.input.value = normalizedValue;
        }
        const selectedOption = this.querySelector('[aria-selected="true"] a');
        if (!selectedOption) {
          const searchUrl = `${window.shopUrl || ''}/search?q=${encodeURIComponent(normalizedValue)}`;
          window.location.href = searchUrl;
          event.preventDefault();
        }
      }
    }
  
    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) {
          this.close();
        }
      });
    }
  
    onKeyup(event) {
      if (this.getQuery().length === 0) {
        this.clear();
        return;
      }
      event.preventDefault();
      switch(event.code) {
        case 'ArrowUp':
          this.switchOption('up');
          break;
        case 'ArrowDown':
          this.switchOption('down');
          break;
        case 'Enter':
          this.selectOption();
          break;
      }
    }
  
    onKeydown(event) {
      if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
        event.preventDefault();
      }
    }
  
    switchOption(direction) {
      if (!this.getAttribute('open')) return;
      const isUp = direction === 'up';
      const selected = this.querySelector('[aria-selected="true"]');
      const options = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(el => el.offsetParent !== null);
      let newIndex = 0;
      if (isUp && !selected) return;
      let currentIndex = -1;
      for (let i = 0; i <= options.length && currentIndex === -1; i++) {
        if (options[i] === selected) {
          currentIndex = i;
        }
      }
      if (this.statusElement) this.statusElement.textContent = '';
      if (!isUp && selected) {
        newIndex = currentIndex === options.length - 1 ? 0 : currentIndex + 1;
      } else {
        newIndex = currentIndex === 0 ? options.length - 1 : currentIndex - 1;
      }
      if (newIndex === currentIndex) return;
      const newOption = options[newIndex];
      newOption.setAttribute('aria-selected', 'true');
      if (selected) selected.setAttribute('aria-selected', 'false');
      if (this.input) this.input.setAttribute('aria-activedescendant', newOption.id);
    }
  
    selectOption() {
      const selected = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
      if (selected) selected.click();
    }
  
    getQuery() {
      return this.input.value.trim();
    }
  
    normalizeGreekText(text) {
      return text.toLowerCase().trim();
    }
  
    clear(event = null) {
      event && event.preventDefault();
      if (this.searchRecommendationEmpty && this.searchContent) {
        this.searchContent.classList.add('hidden');
      }
      if (this.input) {
        this.input.value = '';
        this.input.focus();
      }
      this.removeAttribute('results');
      const maybeBox = this.searchContent?.querySelector('#maybe-you-meant-placeholder');
      if (maybeBox) maybeBox.innerHTML = '';
      const fuzzyContainer = document.getElementById('predictive-fuzzy-results');
      if (fuzzyContainer) {
        fuzzyContainer.innerHTML = '';
        fuzzyContainer.style.display = 'none';
        fuzzyContainer.style.visibility = 'hidden';
        fuzzyContainer.style.opacity = '0';
      }
      const fuzzyHeading = document.querySelector('.predictive-search-result__heading');
      if (fuzzyHeading) {
        fuzzyHeading.remove();
      }
      this.close(true);
    }
  
    onFormReset(event) {
      super.onFormReset(event);
      if (this.shouldResetForm()) {
        this.searchTerm = '';
        if (this.abortController) {
          this.abortController.abort();
        }
        this.abortController = new AbortController();
        this.closeResults(true);
      }
    }
  
    setupURL() {
      const normalizedQuery = this.normalizeGreekText(this.getQuery());
      const url = new URL(`${window.shopUrl || ''}${routes.predictive_search_url}`);
      url.searchParams.set('q', normalizedQuery);
      url.searchParams.set('section_id', 'predictive-search');
      return url;
    }
  
    getSectionId() {
      return this.dataset.sectionId || 'predictive-search';
    }
  
    onFocus(event) {
      const query = this.getQuery();
      if (query.length > 0) {
        if (this.searchTerm !== query) {
          this.onChange();
        } else if (this.getAttribute('results') === 'true') {
          this.open();
        } else {
          this.getSearchResults(this.searchTerm);
        }
      }
    }
  
    onChange() {
      if (this.getQuery().length === 0) {
        this.clear();
        return;
      }
      
      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();
      
      const sectionId = this.getSectionId();
      const resultsId = 'PredictiveSearchResults-' + sectionId;
      const altResultsId = 'SearchDrawerResults-' + sectionId;
      
      const resultsContainer = document.getElementById(resultsId) || document.getElementById(altResultsId);
      if (resultsContainer) {
        resultsContainer.innerHTML = '';
      }
      
      const maybeBox = this.searchContent?.querySelector('#maybe-you-meant-placeholder');
      if (maybeBox) {
        maybeBox.remove();
      }
      
      const fuzzyContainer = document.getElementById('predictive-fuzzy-results');
      if (fuzzyContainer) {
        fuzzyContainer.innerHTML = '';
        fuzzyContainer.style.display = 'none';
        fuzzyContainer.style.visibility = 'hidden';
        fuzzyContainer.style.opacity = '0';
      }
      
      const fuzzyHeading = document.querySelector('.predictive-search-result__heading');
      if (fuzzyHeading) {
        fuzzyHeading.remove();
      }
      
      this.hideMainSearchLoader();
      this.hideFuzzyLoader();
      this.hideMaybeYouMeantLoader();
      
      const url = this.setupURL().toString();
      this.renderSection(url);
      const query = this.getQuery();
      if (query.length >= 1) {
        this.handleMaybeYouMeantPlaceholder(query).catch(err => {
          if (err.name !== 'AbortError') {
            console.error('Error handling maybe-you-meant placeholder:', err);
          }
        });
        this.fetchAndShowFuzzyResults(query).catch(err => {
          if (err.name !== 'AbortError') {
            console.error('Error fetching fuzzy results:', err);
          }
        });
      }
      
      setTimeout(() => {
        const collectionsSection = this.querySelector('.predictive-search-result--collections');
        if (collectionsSection) {
          collectionsSection.style.display = 'block';
          collectionsSection.style.visibility = 'visible';
          collectionsSection.style.opacity = '1';
        }
      }, 100);
    }
  
  
    delegateAddToCartButtons() {
      this.searchContent
        ?.querySelectorAll(".predictive-search__add-button")
        .forEach((button) => {
          button.removeEventListener("click", this.handleAddToCartClick);
          button.addEventListener("click", this.handleAddToCartClick.bind(this));
        });
    }
  
    handleAddToCartClick(event) {
      event.preventDefault();
      const button = event.currentTarget;
      const productId = button.dataset.productId;
      const quantity = parseInt(button.dataset.quantity || "1", 10);
  
      if (!productId) return;
  
      const buttonText = button.querySelector('.button-text');
      const spinner = button.querySelector('.loading__spinner');
  
      button.classList.add("btn--loading");
      button.setAttribute("aria-disabled", "true");
      if (buttonText) buttonText.style.display = "none";
      if (spinner) spinner.classList.remove("hidden");
  
      const formData = new FormData();
      formData.set("id", productId);
      formData.set("quantity", quantity);
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:grouped-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );
      formData.append("sections", sectionsToBundle);
      formData.append("sections_url", window.location.pathname);
  
      const config = {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        },
        body: formData
      };
  
      fetch(routes.cart_add_url, config)
        .then((response) => response.json())
        .then(async (parsedState) => {
          if (parsedState.status) {
            const errorMessage = parsedState.description || "Error adding to cart";
            document.dispatchEvent(new CustomEvent("toast:show", {
              detail: { message: errorMessage }
            }));
            
            const errorDiv = button.closest('.product-card-2')?.querySelector('.product-form__error-message');
            if (errorDiv) {
              errorDiv.textContent = errorMessage;
              errorDiv.removeAttribute('hidden');
              setTimeout(() => {
                errorDiv.setAttribute('hidden', '');
              }, 2000);
            }
            return;
          }
  
          const cartJson = await (await fetch(routes.cart_url)).json();
          cartJson["sections"] = parsedState["sections"];
          document.dispatchEvent(new CustomEvent("cart:update", {
            detail: { cart: cartJson }
          }));
  
          document.dispatchEvent(new CustomEvent("toast:show", {
            detail: { message: `${parsedState.title || "Product"} added to cart` }
          }));
  
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer?.show) cartDrawer.show(button);
  
          const searchDrawer = document.querySelector('search-drawer');
          if (searchDrawer?.hide) searchDrawer.hide();
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
          
          // Show error in error div
          const errorDiv = button.closest('.product-card-2').querySelector('.product-form__error-message');
          if (errorDiv) {
            errorDiv.textContent = "Network error occurred while adding to cart";
            errorDiv.removeAttribute('hidden');
            // Hide error after 2 seconds
            setTimeout(() => {
              errorDiv.setAttribute('hidden', '');
            }, 2000);
          }
        })
        .finally(() => {
          button.classList.remove("btn--loading");
          button.removeAttribute("aria-disabled");
          if (buttonText) buttonText.style.display = "";
          if (spinner) spinner.style.display = "none";
        });
    }
  
    async fetchAndSuggestSimilarProducts(query) {
      const graphqlQuery = {
        query: `
          query {
            products(first: 250) {
              edges {
                node {
                  id
                  title
                  handle
                  tags
                  featuredImage {
                    url
                    altText
                  }
                  variants(first: 250) {
                    edges {
                      node {
                        availableForSale
                      }
                    }
                  }
                }
              }
            }
          }
        `
      };
  
      try {
        const res = await fetch("/api/2025-10/graphql.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": "c6d9974d72d77faac424c49c22f624c8"
          },
          body: JSON.stringify(graphqlQuery)
        });
  
        const json = await res.json();
        const allProducts = json?.data?.products?.edges?.map(e => e.node) || [];
  
        if (!allProducts.length) return;

        const availableProducts = allProducts.filter(product => {
          if (!product.variants || !product.variants.edges || product.variants.edges.length === 0) {
            return false;
          }
          const variants = product.variants.edges.map(e => e.node);
          return variants.some(v => v.availableForSale);
        });
  
        const matches = this.fuzzySearchTagFirst(availableProducts, query, "title").slice(0, 10);
        if (matches.length > 0) this.renderMaybeYouMeant(matches);
      } catch (err) {
        console.error("Failed fuzzy suggestion:", err);
      }
    }
  
    // New method to fetch and search collections
    async fetchAndSearchCollections(query) {
      const coreCollectionHandles = ['thca-flower', 'thca-ounces', 'thca-smalls', 'thca-gummies', 'thca-vape-carts', 'thca-concentrates', 'mushroom', 'thca-shake', 'thca-subscriptions'];
      
      const collectionQueries = coreCollectionHandles.map(handle => `
        ${handle.replace(/-/g, '_')}: collection(handle: "${handle}") {
          id
          title
          handle
          description
          image {
            url
            altText
          }
          products(first: 20) {
            edges {
              node {
                tags
              }
            }
          }
        }
      `).join('\n');

      const graphqlQuery = {
        query: `
          query {
            ${collectionQueries}
          }
        `
      }; 
  
      try {
        const res = await fetch("/api/2025-10/graphql.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": "c6d9974d72d77faac424c49c22f624c8"
          },
          body: JSON.stringify(graphqlQuery)
        });
  
        const json = await res.json();
        const data = json?.data || {};
        
        const coreCollections = coreCollectionHandles
          .map(handle => {
            const key = handle.replace(/-/g, '_');
            return data[key] || null;
          })
          .filter(collection => collection !== null);
  
        return coreCollections;
      } catch (err) {
        console.error("Failed collections search:", err);
        return [];
      }
    }
  
    // Fuzzy search specifically for collections with improved 99% matching
    fuzzySearchCollections(collections, query, key) {
      function normalizeText(str) {
        return this.normalizeGreekText(str);
      }
  
      const queryNormalized = normalizeText.call(this, query);
      const queryWords = queryNormalized.split(/\s+/).filter(word => word.length > 0);
      
      if (queryNormalized.length < 1) {
        return [];
      }
      
      const calculateFieldScore = (text, isTag = false) => {
        if (!text) return 0;
        const textNormalized = normalizeText.call(this, text);
        let score = 0;
        let exactMatchBonus = 0;
        let wordMatchBonus = 0;
        let consecutiveMatchBonus = 0;
        let startMatchBonus = 0;
        let characterMatchBonus = 0;
        
        const queryCharsForMatch = queryNormalized.split('');
        const textCharsForMatch = textNormalized.split('');
        
        let charMatches = 0;
        for (const char of queryCharsForMatch) {
          if (textCharsForMatch.includes(char)) {
            charMatches++;
          }
        }
        
        if (charMatches === 0) {
          return 0;
        }
        
        characterMatchBonus = (charMatches / queryCharsForMatch.length) * (isTag ? 8 : 10);
        
        if (textNormalized.includes(queryNormalized)) {
          exactMatchBonus = isTag ? 25 : 30;
        }
        
        let matchedWords = 0;
        for (const word of queryWords) {
          if (textNormalized.includes(word)) {
            matchedWords++;
            wordMatchBonus += isTag ? Math.max(6, word.length * 1.5) : Math.max(8, word.length * 2);
          }
        }
        
        const queryChars = queryNormalized.split('');
        let consecutiveCount = 0;
        let maxConsecutive = 0;
        let queryIndex = 0;
        
        for (let i = 0; i < textNormalized.length && queryIndex < queryChars.length; i++) {
          if (textNormalized[i] === queryChars[queryIndex]) {
            consecutiveCount++;
            queryIndex++;
          } else {
            if (consecutiveCount > maxConsecutive) {
              maxConsecutive = consecutiveCount;
            }
            consecutiveCount = 0;
          }
        }
        
        if (consecutiveCount > maxConsecutive) {
          maxConsecutive = consecutiveCount;
        }
        
        consecutiveMatchBonus = maxConsecutive / queryChars.length * (isTag ? 8 : 10);
        
        if (textNormalized.startsWith(queryNormalized)) {
          startMatchBonus = isTag ? 15 : 20;
        }
        
        score = exactMatchBonus + wordMatchBonus + consecutiveMatchBonus + startMatchBonus + characterMatchBonus;
        return score;
      };
      
      return collections
        .map(collection => {
          const titleScore = calculateFieldScore(collection[key] || collection.title, false);
          
          let tagsScore = 0;
          if (collection.products && collection.products.edges && collection.products.edges.length > 0) {
            const allTags = [];
            collection.products.edges.forEach(edge => {
              if (edge.node && edge.node.tags && Array.isArray(edge.node.tags)) {
                allTags.push(...edge.node.tags);
              }
            });
            if (allTags.length > 0) {
              const uniqueTags = [...new Set(allTags)];
              const tagsText = uniqueTags.join(' ');
              tagsScore = calculateFieldScore(tagsText, true);
            }
          }
          
          const totalScore = titleScore + tagsScore;
          
          if (totalScore === 0) {
            return {
              item: collection,
              score: 0,
              exactMatch: false,
              wordMatches: 0,
              consecutiveScore: 0,
              startMatch: false
            };
          }
          
          const textNormalized = normalizeText.call(this, collection[key] || collection.title);
          let hasExactMatch = textNormalized.includes(queryNormalized);
          let hasStartMatch = textNormalized.startsWith(queryNormalized);
          let hasTagMatch = false;
          
          if (collection.products && collection.products.edges) {
            const allTags = [];
            collection.products.edges.forEach(edge => {
              if (edge.node && edge.node.tags && Array.isArray(edge.node.tags)) {
                allTags.push(...edge.node.tags);
              }
            });
            if (allTags.length > 0) {
              const tagsText = allTags.join(' ');
              const tagsNormalized = normalizeText.call(this, tagsText);
              if (tagsNormalized.includes(queryNormalized)) {
                hasExactMatch = true;
                hasTagMatch = true;
              }
              if (!hasTagMatch) {
                hasTagMatch = allTags.some(tag => {
                  const tagNormalized = normalizeText.call(this, tag);
                  return tagNormalized.includes(queryNormalized) || queryWords.some(word => tagNormalized.includes(word));
                });
              }
            }
          }
          
          let matchedWords = 0;
          for (const word of queryWords) {
            if (textNormalized.includes(word)) {
              matchedWords++;
            } else if (collection.products && collection.products.edges) {
              const allTags = [];
              collection.products.edges.forEach(edge => {
                if (edge.node && edge.node.tags && Array.isArray(edge.node.tags)) {
                  allTags.push(...edge.node.tags);
                }
              });
              if (allTags.some(tag => normalizeText.call(this, tag).includes(word))) {
                matchedWords++;
              }
            }
          }
          
          const finalScore = totalScore + Math.min((collection.products?.totalCount || 0) / 20, 2);
          
          return {
            item: collection,
            score: finalScore,
            exactMatch: hasExactMatch,
            wordMatches: matchedWords,
            consecutiveScore: 0,
            startMatch: hasStartMatch,
            semanticMatch: false,
            hasTagMatch: hasTagMatch || false,
          };
        })
        .filter(result => result.score >= 0.1)
        .sort((a, b) => {
          if (b.hasTagMatch !== a.hasTagMatch) {
            return b.hasTagMatch ? -1 : 1;
          }
          if (b.score !== a.score) {
            return b.score - a.score;
          }
          if (b.exactMatch !== a.exactMatch) {
            return b.exactMatch ? -1 : 1;
          }
          if (b.startMatch !== a.startMatch) {
            return b.startMatch ? -1 : 1;
          }
          if (b.wordMatches !== a.wordMatches) {
            return b.wordMatches - a.wordMatches;
          }
          return b.consecutiveScore - a.consecutiveScore;
        })
        .map(result => result.item);
    }
  
    fuzzySearchTagFirst(products, query, key) {
      function normalizeText(str) {
        return this.normalizeGreekText(str);
      }

      const queryNormalized = normalizeText.call(this, query);
      const queryWords = queryNormalized.split(/\s+/).filter(word => word.length > 0);
      
      if (queryNormalized.length < 1) {
        return [];
      }

      const tagMatches = products.filter(product => {
        if (!product.tags || !Array.isArray(product.tags) || product.tags.length === 0) {
          return false;
        }
        return product.tags.some(tag => {
          const tagNormalized = normalizeText.call(this, tag);
          return tagNormalized.includes(queryNormalized) || queryWords.some(word => tagNormalized.includes(word));
        });
      });

      if (tagMatches.length > 0) {
        return this.fuzzySearch(tagMatches, query, key);
      }

      const titleMatches = products.filter(product => {
        const textNormalized = normalizeText.call(this, product[key] || product.title);
        return textNormalized.includes(queryNormalized) || queryWords.some(word => textNormalized.includes(word));
      });

      if (titleMatches.length > 0) {
        return this.fuzzySearch(titleMatches, query, key);
      }

      return [];
    }

    fuzzySearch(products, query, key) {
      function normalizeText(str) {
        return this.normalizeGreekText(str);
      }

      const queryNormalized = normalizeText.call(this, query);
      const queryWords = queryNormalized.split(/\s+/).filter(word => word.length > 0);
      
      if (queryNormalized.length < 1) {
        return [];
      }
      
      const calculateFieldScore = (text, isTag = false) => {
        if (!text) return 0;
        const textNormalized = normalizeText.call(this, text);
        let score = 0;
        let exactMatchBonus = 0;
        let wordMatchBonus = 0;
        let consecutiveMatchBonus = 0;
        let startMatchBonus = 0;
        let minimumMatchBonus = 0;
        
        let hasMinimumMatch = false;
        if (queryNormalized.length >= 1) {
          for (let i = 0; i <= textNormalized.length - queryNormalized.length; i++) {
            const substring = textNormalized.substring(i, i + queryNormalized.length);
            if (substring === queryNormalized) {
              hasMinimumMatch = true;
              minimumMatchBonus = 5;
              break;
            }
          }
        }
        
        if (!hasMinimumMatch) {
          const queryChars = queryNormalized.split('');
          const textChars = textNormalized.split('');
          const matchingChars = queryChars.filter(char => textChars.includes(char));
          if (matchingChars.length === 0) {
            return 0;
          }
          minimumMatchBonus = 2;
        }
        
        if (textNormalized.includes(queryNormalized)) {
          exactMatchBonus = isTag ? 20 : 25;
        }
        
        let matchedWords = 0;
        for (const word of queryWords) {
          if (textNormalized.includes(word)) {
            matchedWords++;
            wordMatchBonus += isTag ? 5 : 6;
          }
        }
        
        const queryChars = queryNormalized.split('');
        let consecutiveCount = 0;
        let maxConsecutive = 0;
        let queryIndex = 0;
        
        for (let i = 0; i < textNormalized.length && queryIndex < queryChars.length; i++) {
          if (textNormalized[i] === queryChars[queryIndex]) {
            consecutiveCount++;
            queryIndex++;
          } else {
            if (consecutiveCount > maxConsecutive) {
              maxConsecutive = consecutiveCount;
            }
            consecutiveCount = 0;
          }
        }
        
        if (consecutiveCount > maxConsecutive) {
          maxConsecutive = consecutiveCount;
        }
        
        consecutiveMatchBonus = maxConsecutive / queryChars.length * (isTag ? 6 : 8);
        
        if (textNormalized.startsWith(queryNormalized)) {
          startMatchBonus = isTag ? 12 : 15;
        }
        
        score = exactMatchBonus + wordMatchBonus + consecutiveMatchBonus + startMatchBonus + minimumMatchBonus;
        
        if (!isTag) {
          const lengthBonus = Math.max(0, (50 - textNormalized.length) / 50);
          score += lengthBonus;
        }
        
        return score;
      };
      
      return products
        .map(product => {
          let tagsScore = 0;
          let hasTagMatch = false;
          
          if (product.tags && Array.isArray(product.tags) && product.tags.length > 0) {
            const tagsText = product.tags.join(' ');
            tagsScore = calculateFieldScore(tagsText, true) * 2;
            hasTagMatch = product.tags.some(tag => {
              const tagNormalized = normalizeText.call(this, tag);
              return tagNormalized.includes(queryNormalized) || queryWords.some(word => tagNormalized.includes(word));
            });
          }
          
          const titleScore = calculateFieldScore(product[key] || product.title, false);
          
          const totalScore = tagsScore + titleScore;
          
          if (totalScore === 0) {
            return {
              item: product,
              score: 0,
              exactMatch: false,
              wordMatches: 0,
              consecutiveScore: 0,
              startMatch: false,
            };
          }
          
          const textNormalized = normalizeText.call(this, product[key] || product.title);
          const hasTitleMatch = textNormalized.includes(queryNormalized);
          const hasExactMatch = hasTagMatch || hasTitleMatch || 
            (product.tags && product.tags.some(tag => normalizeText.call(this, tag).includes(queryNormalized)));
          const hasStartMatch = textNormalized.startsWith(queryNormalized) ||
            (product.tags && product.tags.some(tag => {
              const tagNormalized = normalizeText.call(this, tag);
              return tagNormalized.startsWith(queryNormalized);
            }));
          
          let matchedWords = 0;
          for (const word of queryWords) {
            if (textNormalized.includes(word) || 
                (product.tags && product.tags.some(tag => normalizeText.call(this, tag).includes(word)))) {
              matchedWords++;
            }
          }
          
          return {
            item: product,
            score: totalScore,
            exactMatch: hasExactMatch,
            wordMatches: matchedWords,
            consecutiveScore: 0,
            startMatch: hasStartMatch,
            hasTagMatch: hasTagMatch || false,
          };
        })
        .filter(result => result.score >= 0.1)
        .sort((a, b) => {
          if (b.hasTagMatch !== a.hasTagMatch) {
            return b.hasTagMatch ? -1 : 1;
          }
          if (b.score !== a.score) {
            return b.score - a.score;
          }
          if (b.exactMatch !== a.exactMatch) {
            return b.exactMatch ? -1 : 1;
          }
          if (b.startMatch !== a.startMatch) {
            return b.startMatch ? -1 : 1;
          }
          if (b.wordMatches !== a.wordMatches) {
            return b.wordMatches - a.wordMatches;
          }
          return b.consecutiveScore - a.consecutiveScore;
        })
        .map(result => result.item);
    }
  
    renderMaybeYouMeant(products) {
      let container = this.searchContent.querySelector('#maybe-you-meant-placeholder');
      if (!container) {
        container = document.createElement('div');
        container.id = 'maybe-you-meant-placeholder';
        this.searchContent.appendChild(container);
      }
      
      // Filter out out-of-stock products
      const inStockProducts = products.filter(p => this.isProductInStock(p));
      
      const list = document.createElement('ul');
      list.className = 'predictive-search__maybe-you-meant';
  
      const title = document.createElement('h4');
      title.textContent = 'Maybe you meant';
      title.className = 'h5 predictive-search-result__heading mb-3';
  
      inStockProducts.forEach(p => {
        const li = document.createElement('li');
        li.className = 'maybe-you-meant-item';
        const link = document.createElement('a');
        link.href = `/products/${p.handle}`;
        link.className = 'reversed-link maybe-you-meant-link';
        
        // Create image element
        if (p.featuredImage && p.featuredImage.url) {
          const img = document.createElement('img');
          img.src = p.featuredImage.url;
          img.alt = p.featuredImage.altText || p.title;
          img.style.width = '60px';
          img.style.height = '60px';
          img.style.objectFit = 'cover';
          img.style.borderRadius = '4px';
          img.style.flexShrink = '0';
          li.appendChild(img);
        }
        
        // Create text container
        link.textContent = p.title;
        const pcard = document.createElement('p');
        pcard.appendChild(link);
        li.appendChild(pcard);
        list.appendChild(li);
      });
      
      container.innerHTML = '';
      container.appendChild(title);
      container.appendChild(list);
      // Highlight matches in maybe-you-meant links
      this.highlightMaybeYouMeantMatches();
    }
  
    highlightMaybeYouMeantMatches() {
      const query = this.getQuery();
      if (!query || !this.searchContent) return;
      
      // Create normalized query for better matching
      const normalizedQuery = this.normalizeGreekText(query);
      const queryWords = normalizedQuery.split(/\s+/).filter(word => word.length > 2);
      if (queryWords.length === 0) return;
      
      const escapedWords = queryWords.map(word => word.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
      const regex = new RegExp(`\\b(${escapedWords.join('|')})\\b`, 'gi');
      const highlightTextNodes = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const replaced = node.textContent.replace(regex, '<strong>$1</strong>');
          if (replaced !== node.textContent) {
            const span = document.createElement('span');
            span.innerHTML = replaced;
            node.replaceWith(...span.childNodes);
          }
        } else if (node.nodeType === Node.ELEMENT_NODE && node.childNodes.length > 0) {
          node.childNodes.forEach(highlightTextNodes);
        }
      };
      
      this.searchContent.querySelectorAll('.maybe-you-meant-link').forEach(highlightTextNodes);
    }
  
    highlightMatches() {
      const query = this.getQuery();
      if (!query || !this.searchContent) return;
  
      // Create normalized query for better matching
      const normalizedQuery = this.normalizeGreekText(query);
      const queryWords = normalizedQuery.split(/\s+/).filter(word => word.length > 2);
      if (queryWords.length === 0) return;
  
      const escapedWords = queryWords.map(word => word.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
      const regex = new RegExp(`\\b(${escapedWords.join('|')})\\b`, 'gi');
      const highlightTextNodes = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const replaced = node.textContent.replace(regex, '<strong>$1</strong>');
          if (replaced !== node.textContent) {
            const span = document.createElement('span');
            span.innerHTML = replaced;
            node.replaceWith(...span.childNodes);
          }
        } else if (node.nodeType === Node.ELEMENT_NODE && node.childNodes.length > 0) {
          node.childNodes.forEach(highlightTextNodes);
        }
      };
      this.searchContent.querySelectorAll('.reversed-link').forEach(highlightTextNodes);
    }
  
    handleClickOutside(event) {
      if (!this.contains(event.target)) {
        setTimeout(() => {
          document.body.classList.remove('predictive-search-open');
        });
      }
    }
  
    displayFuzzyResults(products) {
      // Filter out out-of-stock products
      const inStockProducts = products.filter(p => this.isProductInStock(p));
      
      console.log('displayFuzzyResults called with products:', inStockProducts.length);
      let container = document.getElementById('predictive-fuzzy-results');
      console.log('Container found:', !!container);
      if (!container) {
        container = document.createElement('div');
        container.id = 'predictive-fuzzy-results';
        container.style.display = 'grid';
        container.style.visibility = 'visible';
        if (this.searchContent) {
          console.log('Using searchContent');
          const resultsBox = this.searchContent.querySelector('.search__results') || this.searchContent.querySelector('.search__box');
          if (resultsBox) {
            resultsBox.appendChild(container);
          } else {
            this.searchContent.appendChild(container);
          }
        } else {
          console.log('Using fallback container');
          const searchResults = document.querySelector('[id^="PredictiveSearchResults"]');
          if (searchResults) {
            searchResults.appendChild(container);
          } else {
            document.body.appendChild(container);
          }
        }
      }
      container.style.display = 'grid';
      container.style.visibility = 'visible';
      container.style.opacity = '1';
      
      if (this.searchContent) {
        this.searchContent.classList.remove('hidden');
        this.searchContent.style.display = '';
      }
      
      const noPopularMsg = document.querySelector('.no-data-found');
      if (noPopularMsg && products.length > 0) {
        noPopularMsg.style.display = 'none';
      }
      if (container.parentNode) {
        const existingHeading = container.parentNode.querySelector('.predictive-search-result__heading');
        if (existingHeading) {
          existingHeading.remove();
        }
      }
      
      container.innerHTML = '';
      if (!inStockProducts.length) {
        const noResultsDiv = document.createElement('p');
        noResultsDiv.className = 'no-fuzzy-results-found';
        noResultsDiv.style.cssText = 'text-align: center; padding: 20px;';
        noResultsDiv.textContent = 'No results found';
        container.appendChild(noResultsDiv);
        return;
      }
      
      const heading = document.createElement('h4');
      heading.className = 'h5 predictive-search-result__heading';
      heading.textContent = `Products (${inStockProducts.length})`;
      heading.style.marginBottom = '1rem';
      if (container.parentNode) {
        container.parentNode.insertBefore(heading, container);
      }
      
      const list = document.createElement('ul');
      list.className = 'predictive-search__fuzzy-results grid gap-4';
      inStockProducts.forEach((p, idx) => {
        const li = document.createElement('li');
        li.id = `predictive-fuzzy-result-product-${idx+1}`;
        li.className = 'predictive-search__list-item product-card-2';
        li.setAttribute('role', 'option');
        li.style.cssText = 'border-bottom: 1px solid #e5e5e5; padding-bottom: 1rem; margin-bottom: 1rem;';
  
        const flexDiv = document.createElement('div');
        flexDiv.className = 'flex gap-6 items-center';
        flexDiv.style.width = '100%';
  
        // Image
        if (p.featuredImage && p.featuredImage.url) {
          const aImg = document.createElement('a');
          aImg.href = `/products/${p.handle}`;
          aImg.className = 'media-wrapper blocks-radius-sm';
          const img = document.createElement('img');
          img.src = p.featuredImage.url;
          img.alt = p.featuredImage.altText || p.title;
          img.loading = 'lazy';
          img.width = 100;
          img.height = 100;
          img.style.objectFit = 'cover';
          img.style.borderRadius = '4px';
          aImg.appendChild(img);
          flexDiv.appendChild(aImg);
        }
  
        // Info
        const infoDiv = document.createElement('div');
        infoDiv.className = 'grid gap-1';
        infoDiv.style.flex = '1';
  
        // Title
        const pTitle = document.createElement('p');
        pTitle.className = 'block m-0';
        const aTitle = document.createElement('a');
        aTitle.href = `/products/${p.handle}`;
        aTitle.className = 'reversed-link text-pcard-title fuzzy-result-link';
        aTitle.textContent = p.title;
        pTitle.appendChild(aTitle);
        infoDiv.appendChild(pTitle);
  
        // Price (if available)
        if (p.priceRange && p.priceRange.minVariantPrice) {
          const priceDiv = document.createElement('div');
          priceDiv.className = 'text-price';
          const minPrice = parseFloat(p.priceRange.minVariantPrice.amount);
          const maxPrice = parseFloat(p.priceRange.maxVariantPrice.amount);
          const currencyCode = p.priceRange.minVariantPrice.currencyCode;
          let formattedPrice = '';
          
          if (minPrice === maxPrice) {
            formattedPrice = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: currencyCode,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(minPrice);
          } else {
            const formattedMin = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: currencyCode,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(minPrice);
            const formattedMax = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: currencyCode,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(maxPrice);
            formattedPrice = `${formattedMin} - ${formattedMax}`;
          }
          
          priceDiv.textContent = formattedPrice;
          infoDiv.appendChild(priceDiv);
        }
  
        flexDiv.appendChild(infoDiv);
  
        li.appendChild(flexDiv);
        list.appendChild(li);
      });
      container.appendChild(list);
      this.highlightFuzzyMatches();
      this.delegateAddToCartButtons();
    }

    displayAllFuzzyResults(products, collections, pages) {
      let container = document.getElementById('predictive-fuzzy-results');
      if (!container) {
        container = document.createElement('div');
        container.id = 'predictive-fuzzy-results';
        container.style.display = 'grid';
        container.style.visibility = 'visible';
        if (this.searchContent) {
          const resultsBox = this.searchContent.querySelector('.search__results') || this.searchContent.querySelector('.search__box');
          if (resultsBox) {
            resultsBox.appendChild(container);
          } else {
            this.searchContent.appendChild(container);
          }
        } else {
          const searchResults = document.querySelector('[id^="PredictiveSearchResults"]');
          if (searchResults) {
            searchResults.appendChild(container);
          } else {
            document.body.appendChild(container);
          }
        }
      }
      container.style.display = 'grid';
      container.style.visibility = 'visible';
      container.style.opacity = '1';
      
      if (this.searchContent) {
        this.searchContent.classList.remove('hidden');
        this.searchContent.style.display = '';
      }
      
      const noPopularMsg = document.querySelector('.no-data-found');
      if (noPopularMsg && products.length > 0) {
        noPopularMsg.style.display = 'none';
      }
      
      if (container.parentNode) {
        const existingHeading = container.parentNode.querySelector('.predictive-search-result__heading');
        if (existingHeading) {
          existingHeading.remove();
        }
      }
      
      container.innerHTML = '';
      
      const totalResults = inStockProducts.length;
      if (totalResults === 0) {
        const noResultsDiv = document.createElement('p');
        noResultsDiv.className = 'no-fuzzy-results-found';
        noResultsDiv.style.cssText = 'text-align: center; padding: 20px;';
        noResultsDiv.textContent = 'No results found';
        container.appendChild(noResultsDiv);
        return;
      }

      if (products.length > 0) {
        const limitedProducts = products.slice(0, 15);
        const heading = document.createElement('h4');
        heading.className = 'h5 predictive-search-result__heading';
        heading.textContent = `Products (${limitedProducts.length})`;
        if (container.parentNode) {
          container.parentNode.insertBefore(heading, container);
        }
        
        const productsSection = document.createElement('div');
        productsSection.className = 'grid gap-3 predictive-search-result search__box-item predictive-search-result--products';
        
        const list = document.createElement('ul');
        list.className = 'predictive-search__fuzzy-results grid gap-4';
        
        limitedProducts.forEach((p, idx) => {
          const li = document.createElement('li');
          li.id = `predictive-fuzzy-result-product-${idx+1}`;
          li.className = 'predictive-search__list-item product-card-2';
          li.setAttribute('role', 'option');
          li.style.cssText = 'border-bottom: 1px solid #e5e5e5; padding-bottom: 1rem; margin-bottom: 1rem;';
    
          const flexDiv = document.createElement('div');
          flexDiv.className = 'flex gap-6 items-center';
          flexDiv.style.width = '100%';
    
          if (p.featuredImage && p.featuredImage.url) {
            const aImg = document.createElement('a');
            aImg.href = `/products/${p.handle}`;
            aImg.className = 'media-wrapper blocks-radius-sm';
            const img = document.createElement('img');
            img.src = p.featuredImage.url;
            img.alt = p.featuredImage.altText || p.title;
            img.loading = 'lazy';
            img.width = 100;
            img.height = 100;
            img.style.objectFit = 'cover';
            img.style.borderRadius = '4px';
            aImg.appendChild(img);
            flexDiv.appendChild(aImg);
          }
    
          const infoDiv = document.createElement('div');
          infoDiv.className = 'grid gap-1';
          infoDiv.style.flex = '1';
    
          const pTitle = document.createElement('p');
          pTitle.className = 'block m-0';
          const aTitle = document.createElement('a');
          aTitle.href = `/products/${p.handle}`;
          aTitle.className = 'reversed-link text-pcard-title fuzzy-result-link';
          aTitle.textContent = p.title;
          pTitle.appendChild(aTitle);
          infoDiv.appendChild(pTitle);
    
          if (p.priceRange && p.priceRange.minVariantPrice) {
            const priceDiv = document.createElement('div');
            priceDiv.className = 'text-price';
            const minPrice = parseFloat(p.priceRange.minVariantPrice.amount);
            const maxPrice = parseFloat(p.priceRange.maxVariantPrice.amount);
            const currencyCode = p.priceRange.minVariantPrice.currencyCode;
            let formattedPrice = '';
            
            if (minPrice === maxPrice) {
              formattedPrice = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(minPrice);
            } else {
              const formattedMin = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(minPrice);
              const formattedMax = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(maxPrice);
              formattedPrice = `${formattedMin} - ${formattedMax}`;
            }
            
            priceDiv.textContent = formattedPrice;
            infoDiv.appendChild(priceDiv);
          }
    
          flexDiv.appendChild(infoDiv);
    
          li.appendChild(flexDiv);
          list.appendChild(li);
        });
        
        productsSection.appendChild(list);
        container.appendChild(productsSection);
      }

      const collectionsPagesWrapper = document.createElement('div');
      collectionsPagesWrapper.className = 'collections-pages-wrapper';

      const maybeYouMeantContainer = this.searchContent?.querySelector('#maybe-you-meant-placeholder');
      if (maybeYouMeantContainer) {
        collectionsPagesWrapper.appendChild(maybeYouMeantContainer);
      }

      if (maybeYouMeantContainer) {
        container.appendChild(collectionsPagesWrapper);
      }
      
      setTimeout(() => {
        this.highlightFuzzyMatches();
      }, 100);
      this.delegateAddToCartButtons();
    }
  
    highlightFuzzyMatches() {
      const query = this.getQuery();
      const container = document.getElementById('predictive-fuzzy-results');
      if (!query || !container) return;
      const normalizedQuery = this.normalizeGreekText(query);
      const queryWords = normalizedQuery.split(/\s+/).filter(word => word.length > 2);
      if (queryWords.length === 0) return;
      
      const escapedWords = queryWords.map(word => word.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
      const regex = new RegExp(`\\b(${escapedWords.join('|')})\\b`, 'gi');
      
      const highlightElement = (element) => {
        if (!element || element.querySelector('strong')) return;
        
        const walker = document.createTreeWalker(
          element,
          NodeFilter.SHOW_TEXT,
          null,
          false
        );
        
        const textNodes = [];
        let node;
        while (node = walker.nextNode()) {
          if (node.textContent.trim()) {
            textNodes.push(node);
          }
        }
        
        textNodes.forEach(textNode => {
          const replaced = textNode.textContent.replace(regex, '<strong>$1</strong>');
          if (replaced !== textNode.textContent) {
            const span = document.createElement('span');
            span.innerHTML = replaced;
            textNode.parentNode.replaceChild(span, textNode);
          }
        });
      };
      
      container.querySelectorAll('.fuzzy-result-link, .text-pcard-title, .reversed-link').forEach(link => {
        highlightElement(link);
      });
      
      const maybeYouMeantContainer = this.searchContent?.querySelector('#maybe-you-meant-placeholder');
      if (maybeYouMeantContainer) {
        maybeYouMeantContainer.querySelectorAll('.maybe-you-meant-link, span').forEach(element => {
          highlightElement(element);
        });
      }
    }
  
    // Update collections section with dynamic results
    updateCollectionsSection(collections) {
      return;
      const collectionsSection = this.searchContent?.querySelector('.predictive-search-result--collections');
      
      if (!collectionsSection) {
        return;
      }
  
      const heading = collectionsSection.querySelector('.predictive-search-result__heading');
      const list = collectionsSection.querySelector('#predictive-search-results-collection-list');
      const noDataMessage = collectionsSection.querySelector('p');
  
      if (collections.length > 0) {      
        if (heading) {
          heading.textContent = `Categories (${collections.length})`;
        }
  
        // Create new list items
        if (list) {
          list.innerHTML = '';
          collections.forEach((collection, index) => {
            const li = document.createElement('li');
            li.id = `predictive-search-option-collection-${index + 1}`;
            li.className = 'predictive-search__list-item';
            li.setAttribute('role', 'option');
            li.setAttribute('aria-selected', 'false');
            li.style.cssText = 'border-bottom: 1px solid #e5e5e5; padding-bottom: 1rem; margin-bottom: 1rem;';
  
            const link = document.createElement('a');
            link.href = `/collections/${collection.handle}`;
            link.className = 'reversed-link';
            link.textContent = collection.title;
            
            li.appendChild(link);
            list.appendChild(li);
          });
          
        } else {
          // Create the list if it doesn't exist
          const newList = document.createElement('ul');
          newList.id = 'predictive-search-results-collection-list';
          newList.className = 'predictive-search-result__list';
          newList.setAttribute('role', 'group');
          newList.setAttribute('aria-labelledby', 'predictive-search-collection');
          
          collections.forEach((collection, index) => {
            const li = document.createElement('li');
            li.id = `predictive-search-option-collection-${index + 1}`;
            li.className = 'predictive-search__list-item';
            li.setAttribute('role', 'option');
            li.setAttribute('aria-selected', 'false');
            li.style.cssText = 'border-bottom: 1px solid #e5e5e5; padding-bottom: 1rem; margin-bottom: 1rem;';
  
            const link = document.createElement('a');
            link.href = `/collections/${collection.handle}`;
            link.className = 'reversed-link';
            link.textContent = collection.title;
            
            li.appendChild(link);
            newList.appendChild(li);
          });
          
          collectionsSection.appendChild(newList);
        }
  
        // Hide no data message if it exists
        if (noDataMessage) {
          noDataMessage.style.display = 'none';
        }
      } else {
        // Show no data message
        if (heading) {
          heading.textContent = 'Categories (0)';
        }
        
        if (list) {
          list.innerHTML = '';
        }
        
        if (noDataMessage) {
          noDataMessage.style.display = 'block';
          noDataMessage.textContent = 'No Categories found';
        } else {
          // Create no data message if it doesn't exist
          const newNoDataMessage = document.createElement('p');
          newNoDataMessage.textContent = 'No Categories found';
          collectionsSection.appendChild(newNoDataMessage);
        }
      }
  
      // Highlight matches in collection links
      this.highlightCollectionMatches();
    }
  
    // Highlight matches in collection links
    highlightCollectionMatches() {
      return;
    }
  
    // New: Fetch and show 80-90 fuzzy results
    async fetchAllProducts(cursor = null) {
      const allProducts = [];
      let hasNextPage = true;
      let currentCursor = cursor;
      
      while (hasNextPage) {
        const graphqlQuery = {
          query: `
            query searchResults($cursor: String) {
              products(first: 250, after: $cursor) {
                pageInfo {
                  hasNextPage
                  endCursor
                }
                edges {
                  node {
                    id
                    title
                    handle
                    vendor
                    tags
                    featuredImage {
                      url
                      altText
                    }
                    priceRange {
                      minVariantPrice {
                        amount
                        currencyCode
                      }
                      maxVariantPrice {
                        amount
                        currencyCode
                      }
                    }
                    variants(first: 250) {
                      edges {
                        node {
                          id
                          availableForSale
                          price {
                            amount
                            currencyCode
                          }
                          compareAtPrice {
                            amount
                            currencyCode
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
          variables: currentCursor ? { cursor: currentCursor } : {}
        };
        
        try {
          const res = await fetch("/api/2025-10/graphql.json", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": "c6d9974d72d77faac424c49c22f624c8"
            },
            body: JSON.stringify(graphqlQuery)
          });
          const json = await res.json();
          const products = json?.data?.products?.edges?.map(e => e.node) || [];
          allProducts.push(...products);
          
          hasNextPage = json?.data?.products?.pageInfo?.hasNextPage || false;
          currentCursor = json?.data?.products?.pageInfo?.endCursor || null;
        } catch (err) {
          console.error("Failed to fetch products page:", err);
          break;
        }
      }
      
      return allProducts;
    }

    async fetchAndShowFuzzyResults(query) {
      if (query.length < 1) {
        const container = document.getElementById('predictive-fuzzy-results');
        if (container) {
          container.innerHTML = '';
          container.style.display = 'none';
          container.style.visibility = 'hidden';
          container.style.opacity = '0';
        }
        const fuzzyHeading = document.querySelector('.predictive-search-result__heading');
        if (fuzzyHeading) {
          fuzzyHeading.remove();
        }
        this.hideFuzzyLoader();
        return;
      }
  
      this.showFuzzyLoader();
      
      try {
        const allProducts = await this.fetchAllProducts();
        const collections = await this.fetchAllCollections();
        
        const filteredProducts = allProducts.filter(product => {
          if (!product.variants || !product.variants.edges || product.variants.edges.length === 0) {
            return false;
          }
          const variants = product.variants.edges.map(e => e.node);
          return variants.some(v => v.availableForSale);
        });
        
        const productResults = this.fuzzySearchTagFirst(filteredProducts, query, "title").slice(0, 15);
        const collectionResults = this.fuzzySearch(collections, query, "title");
        
        console.log('Fuzzy results found - Products:', productResults.length, 'Collections:', collectionResults.length);
              
        if (this.abortController && this.abortController.signal.aborted) return;
        
        this.displayAllFuzzyResults(productResults, collectionResults, []);
        
        this.hideFuzzyLoader();
      } catch (err) {
        if (err.name === 'AbortError') return;
        console.error("Failed fuzzy results fetch:", err);
        this.hideFuzzyLoader();
      }
    }

    async fetchAllCollections(cursor = null) {
      const allCollections = [];
      let hasNextPage = true;
      let currentCursor = cursor;
      
      while (hasNextPage) {
        const graphqlQuery = {
          query: `
            query searchCollections($cursor: String) {
              collections(first: 250, after: $cursor) {
                pageInfo {
                  hasNextPage
                  endCursor
                }
                edges {
                  node {
                    id
                    title
                    handle
                    description
                    image {
                      url
                      altText
                    }
                    products(first: 10) {
                      edges {
                        node {
                          tags
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
          variables: currentCursor ? { cursor: currentCursor } : {}
        };
        
        try {
          const res = await fetch("/api/2025-10/graphql.json", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": "c6d9974d72d77faac424c49c22f624c8"
            },
            body: JSON.stringify(graphqlQuery)
          });
          const json = await res.json();
          const collections = json?.data?.collections?.edges?.map(e => e.node) || [];
          allCollections.push(...collections);
          
          hasNextPage = json?.data?.collections?.pageInfo?.hasNextPage || false;
          currentCursor = json?.data?.collections?.pageInfo?.endCursor || null;
        } catch (err) {
          console.error("Failed to fetch collections page:", err);
          break;
        }
      }
      
      return allCollections;
    }
  
    // Helper method to calculate product score for filtering
    calculateProductScore(product, query) {
      const queryNormalized = this.normalizeGreekText(query);
      const queryWords = queryNormalized.split(/\s+/).filter(word => word.length > 0);
      const textNormalized = this.normalizeGreekText(product.title);
      
      const calculateFieldScore = (text, isTag = false) => {
        if (!text) return 0;
        const normalized = this.normalizeGreekText(text);
        let score = 0;
        let exactMatchBonus = 0;
        let wordMatchBonus = 0;
        let consecutiveMatchBonus = 0;
        let startMatchBonus = 0;
        let minimumMatchBonus = 0;
        
        let hasMinimumMatch = false;
        for (let i = 0; i <= normalized.length - 3; i++) {
          const substring = normalized.substring(i, i + 3);
          if (queryNormalized.includes(substring)) {
            hasMinimumMatch = true;
            minimumMatchBonus = 5;
            break;
          }
        }
        
        if (normalized.includes(queryNormalized)) {
          exactMatchBonus = isTag ? 20 : 25;
        }
        
        let matchedWords = 0;
        for (const word of queryWords) {
          if (normalized.includes(word)) {
            matchedWords++;
            wordMatchBonus += isTag ? Math.max(5, word.length * 1.2) : Math.max(6, word.length * 1.5);
          }
        }
        
        if (matchedWords > 1) {
          wordMatchBonus += matchedWords * (isTag ? 1.5 : 2);
        }
        
        const queryChars = queryNormalized.split('');
        let consecutiveCount = 0;
        let maxConsecutive = 0;
        let queryIndex = 0;
        
        for (let i = 0; i < normalized.length && queryIndex < queryChars.length; i++) {
          if (normalized[i] === queryChars[queryIndex]) {
            consecutiveCount++;
            queryIndex++;
          } else {
            if (consecutiveCount > maxConsecutive) {
              maxConsecutive = consecutiveCount;
            }
            consecutiveCount = 0;
          }
        }
        
        if (consecutiveCount > maxConsecutive) {
          maxConsecutive = consecutiveCount;
        }
        
        consecutiveMatchBonus = maxConsecutive / queryChars.length * (isTag ? 6 : 8);
        
        if (normalized.startsWith(queryNormalized)) {
          startMatchBonus = isTag ? 12 : 15;
        }
        
        score = exactMatchBonus + wordMatchBonus + consecutiveMatchBonus + startMatchBonus + minimumMatchBonus;
        
        if (!isTag) {
          const lengthBonus = Math.max(0, (50 - normalized.length) / 50);
          score += lengthBonus;
        }
        
        if (matchedWords > 1) {
          score += matchedWords * (isTag ? 2 : 3);
        }
        
        if (queryNormalized.length > 10 && matchedWords > 0) {
          score += isTag ? 3 : 5;
        }
        
        return score;
      };
      
      const titleScore = calculateFieldScore(product.title, false);
      
      let tagsScore = 0;
      if (product.tags && Array.isArray(product.tags) && product.tags.length > 0) {
        const tagsText = product.tags.join(' ');
        tagsScore = calculateFieldScore(tagsText, true);
      }
      
      return titleScore + tagsScore;
    }
  
    // Helper method to calculate Greek similarity
  
    // Helper method to calculate exact match percentage
    calculateExactMatchPercentage(query, title) {
      if (!query || !title) return 0;
      
      const queryWords = query.split(/\s+/).filter(word => word.length > 2);
      const titleWords = title.split(/\s+/).filter(word => word.length > 2);
      
      if (queryWords.length === 0 || titleWords.length === 0) return 0;
      
      let exactWordMatches = 0;
      let partialMatches = 0;
      
      for (const queryWord of queryWords) {
        // Check for exact word matches
        if (titleWords.includes(queryWord)) {
          exactWordMatches++;
        }
        // Check for partial matches (word contains query word or vice versa)
        else if (titleWords.some(titleWord => 
          titleWord.includes(queryWord) || queryWord.includes(titleWord)
        )) {
          partialMatches++;
        }
      }
      
      // Calculate percentage: exact matches get full weight, partial matches get half weight
      const totalScore = exactWordMatches + (partialMatches * 0.5);
      return totalScore / queryWords.length;
    }
  
    // Helper method to check for meaning matches (semantic similarity)
    hasMeaningMatch(query, title) {
      if (!query || !title) return false;
      
      const greekMeanings = {
        'rustic': ['rustic'],
        'modern': ['modern'],
        'vintage': ['vintage'],
        'boho': ['boho', 'bohemian']
      };
      
      const queryWords = query.split(/\s+/).filter(word => word.length > 2);
      const titleWords = title.split(/\s+/).filter(word => word.length > 2);
      
      let meaningMatches = 0;
      
      for (const queryWord of queryWords) {
        // Check if query word has meanings
        if (greekMeanings[queryWord]) {
          const meanings = greekMeanings[queryWord];
          // Check if any meaning matches title words
          if (titleWords.some(titleWord => meanings.includes(titleWord))) {
            meaningMatches++;
          }
        }
        // Check if title word has meanings that match query
        else {
          for (const [key, meanings] of Object.entries(greekMeanings)) {
            if (meanings.includes(queryWord)) {
              if (titleWords.includes(key)) {
                meaningMatches++;
                break;
              }
            }
          }
        }
      }
      
      // Return true if at least 2 meaning matches found
      return meaningMatches >= 2;
    }
  
    getNumericVariantId(gid) {
      if (!gid) return '';
      const match = gid.match(/(\d+)$/);
      return match ? match[1] : gid;
    }
  
    showFuzzyLoader() {
      let loader = document.querySelector('.fuzzy-loader');
      if (!loader) {
        loader = document.createElement('div');
        loader.className = 'fuzzy-loader';
        loader.style.cssText = `
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 99999;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 40px;
          border-radius: 8px;
        `;
        loader.innerHTML = `
          <div class="loading__spinner">
            <svg aria-hidden="true" focusable="false" class="spinner icon icon--medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30" stroke="#000"></circle>
            </svg>
          </div>
        `;
        document.body.appendChild(loader);
        
        if (!document.querySelector('#fuzzy-loader-style')) {
          const style = document.createElement('style');
          style.id = 'fuzzy-loader-style';
          style.textContent = `
            .fuzzy-loader .spinner {
              animation: fuzzyRotate 2s linear infinite;
            }
            .fuzzy-loader .path {
              stroke-dasharray: 90, 150;
              stroke-dashoffset: 0;
              stroke-linecap: round;
              animation: fuzzyDash 1.5s ease-in-out infinite;
            }
            @keyframes fuzzyRotate {
              100% { transform: rotate(360deg); }
            }
            @keyframes fuzzyDash {
              0% {
                stroke-dasharray: 1, 150;
                stroke-dashoffset: 0;
              }
              50% {
                stroke-dasharray: 90, 150;
                stroke-dashoffset: -35;
              }
              100% {
                stroke-dasharray: 90, 150;
                stroke-dashoffset: -124;
              }
            }
          `;
          document.head.appendChild(style);
        }
      } else {
        loader.style.display = 'flex';
      }
    }
  
    hideFuzzyLoader() {
      const loader = document.querySelector('.fuzzy-loader');
      if (loader) {
        loader.remove();
      }
    }
  
    showMainSearchLoader() {
      if (!this.searchContent) return;
      
      const existingLoader = this.searchContent.querySelector('.main-search-loader');
      if (existingLoader) {
        existingLoader.remove();
      }
      
      if (!document.querySelector('#main-search-loader-style')) {
        const style = document.createElement('style');
        style.id = 'main-search-loader-style';
        style.textContent = `
          .main-search-loader .spinner {
            animation: mainSearchRotate 1.4s linear infinite;
          }
          .main-search-loader .path {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: 0;
            stroke-linecap: round;
            stroke: currentColor;
            animation: mainSearchDash 1.4s ease-in-out infinite;
          }
          @keyframes mainSearchRotate {
            100% { transform: rotate(360deg); }
          }
          @keyframes mainSearchDash {
            0% {
              stroke-dasharray: 1, 150;
              stroke-dashoffset: 0;
            }
            50% {
              stroke-dasharray: 90, 150;
              stroke-dashoffset: -35;
            }
            100% {
              stroke-dasharray: 90, 150;
              stroke-dashoffset: -124;
            }
          }
        `;
        document.head.appendChild(style);
      }
      
      const loaderDiv = document.createElement('div');
      loaderDiv.className = 'main-search-loader';
      loaderDiv.style.cssText = `
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        margin: 10px 0;
      `;
      
      loaderDiv.innerHTML = `
        <div class="loading__spinner" style="width: 40px; height: 40px; color: #666;">
          <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width: 100%; height: 100%;">
            <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
      `;
      
      this.searchContent.insertBefore(loaderDiv, this.searchContent.firstChild);
    }
  
    hideMainSearchLoader() {
      if (!this.searchContent) return;
      
      const loader = this.searchContent.querySelector('.main-search-loader');
      if (loader) {
        loader.remove();
      }
    }
  
    // Enhanced function to handle maybe-you-meant-placeholder specifically
    async handleMaybeYouMeantPlaceholder(query) {
      const existingContainers = this.searchContent?.querySelectorAll('#maybe-you-meant-placeholder');
      if (existingContainers && existingContainers.length > 0) {
        existingContainers.forEach(container => container.remove());
      }
      
      let container = document.createElement('div');
      container.id = 'maybe-you-meant-placeholder';
  
      if (query.length < 1) {
        return;
      }
  
      // Show loader
      this.showMaybeYouMeantLoader();
  
      try {
        // Fetch products from GraphQL
        const graphqlQuery = {
          query: `
            query {
              products(first: 250) {
                edges {
                  node {
                    id
                    title
                    handle
                    featuredImage {
                      url
                      altText
                    }
                    variants(first: 250) {
                      edges {
                        node {
                          availableForSale
                        }
                      }
                    }
                  }
                }
              }
            }
          `
        };
  
        const res = await fetch("/api/2025-10/graphql.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": "c6d9974d72d77faac424c49c22f624c8"
          },
          body: JSON.stringify(graphqlQuery)
        });
  
        const json = await res.json();
        const allProducts = json?.data?.products?.edges?.map(e => e.node) || [];
  
        if (!allProducts.length) {
          this.hideMaybeYouMeantLoader();
          return;
        }
  
        const normalizedQuery = this.normalizeGreekText(query);
        const matches = allProducts
          .filter(product => {
            // First check if product is in stock
            if (!product.variants || !product.variants.edges || product.variants.edges.length === 0) {
              return false;
            }
            const variants = product.variants.edges.map(e => e.node);
            const isInStock = variants.some(v => v.availableForSale);
            if (!isInStock) {
              return false;
            }
            
            // Then check if it matches the query
            const productTitle = this.normalizeGreekText(product.title);
            const titleMatch = productTitle.includes(normalizedQuery);
            let tagsMatch = false;
            if (product.tags && Array.isArray(product.tags) && product.tags.length > 0) {
              const tagsText = product.tags.join(' ');
              const normalizedTags = this.normalizeGreekText(tagsText);
              tagsMatch = normalizedTags.includes(normalizedQuery);
            }
            return titleMatch || tagsMatch;
          })
          .slice(0, 10);
  
        // Create suggestion elements with actual products
        if (matches.length > 0) {
          const title = document.createElement('h4');
          title.textContent = 'Maybe you meant';
          title.className = 'h5 predictive-search-result__heading mb-3';
  
          const suggestionList = document.createElement('ul');
          suggestionList.className = 'predictive-search__maybe-you-meant';
  
          matches.forEach(product => {
            const li = document.createElement('li');
            li.className = 'maybe-you-meant-item';
            
            const link = document.createElement('a');
            link.href = `/products/${product.handle}`;
            link.className = 'reversed-link maybe-you-meant-link';
            link.style.display = 'flex';
            link.style.alignItems = 'center';
            link.style.gap = '12px';
            link.style.textDecoration = 'none';
            link.style.color = 'inherit';
            link.style.padding = '8px 12px';
            link.style.borderRadius = '4px';
            link.style.transition = 'transform 0.2s ease, opacity 0.2s ease';
            link.style.willChange = 'transform, opacity';
            link.style.position = 'relative';
            link.style.overflow = 'hidden';
            
            const hoverBg = document.createElement('span');
            hoverBg.style.position = 'absolute';
            hoverBg.style.top = '0';
            hoverBg.style.left = '0';
            hoverBg.style.right = '0';
            hoverBg.style.bottom = '0';
            hoverBg.style.backgroundColor = '#f5f5f5';
            hoverBg.style.opacity = '0';
            hoverBg.style.transition = 'opacity 0.2s ease';
            hoverBg.style.zIndex = '-1';
            hoverBg.style.borderRadius = 'inherit';
            link.appendChild(hoverBg);
            
            link.addEventListener('mouseenter', () => {
              hoverBg.style.opacity = '1';
              link.style.transform = 'translateX(2px)';
            });
            link.addEventListener('mouseleave', () => {
              hoverBg.style.opacity = '0';
              link.style.transform = 'translateX(0)';
            });
            
            // Create product image if available
            if (product.featuredImage && product.featuredImage.url) {
              const img = document.createElement('img');
              img.src = product.featuredImage.url;
              img.alt = product.featuredImage.altText || product.title;
              img.style.width = '40px';
              img.style.height = '40px';
              img.style.objectFit = 'cover';
              img.style.borderRadius = '4px';
              img.style.flexShrink = '0';
              link.appendChild(img);
            }
            
            // Create product title
            const textSpan = document.createElement('span');
            textSpan.textContent = product.title;
            link.appendChild(textSpan);
            
            li.appendChild(link);
            suggestionList.appendChild(li);
          });
  
          container.appendChild(title);
          container.appendChild(suggestionList);
          
          if (this.searchContent && !this.searchContent.contains(container)) {
            this.searchContent.appendChild(container);
          }
          
          // Highlight the original query in product titles
          if (typeof this.highlightQueryInSuggestions === 'function') {
            this.highlightQueryInSuggestions(query);
          }
        } else {
          // Show "no results" message
          const title = document.createElement('h4');
          title.textContent = 'Maybe you meant';
          title.className = 'h5 predictive-search-result__heading mb-3';
          
          const noResults = document.createElement('p');
          noResults.textContent = 'No products found';
          
          container.appendChild(title);
          container.appendChild(noResults);
          
          if (this.searchContent && !this.searchContent.contains(container)) {
            this.searchContent.appendChild(container);
          }
        }
  
      } catch (error) {
        console.error('Error fetching products for suggestions:', error);
        // Show error message
        const title = document.createElement('h4');
        title.textContent = 'Maybe you meant';
        title.className = 'h5 predictive-search-result__heading mb-3';
        
        const errorMsg = document.createElement('p');
        errorMsg.textContent = 'Error during search';
        
        container.appendChild(title);
        container.appendChild(errorMsg);
        
        if (this.searchContent && !this.searchContent.contains(container)) {
          this.searchContent.appendChild(container);
        }
      }
  
      this.hideMaybeYouMeantLoader();
    }
  
    showMaybeYouMeantLoader() {
      let container = this.searchContent?.querySelector('#maybe-you-meant-placeholder-drawer');
      if (!container) {
        container = document.createElement('div');
        container.id = 'maybe-you-meant-placeholder-drawer';
        this.searchContent?.appendChild(container);
      }
      
      container.innerHTML = `
        <div class="maybe-you-meant-loader" style="display: flex; justify-content: center; align-items: center; padding: 20px;">
          <div class="loading__spinner">
            <svg aria-hidden="true" focusable="false" class="spinner icon icon--medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </div>
      `;
    }
  
    hideMaybeYouMeantLoader() {
      const container = this.searchContent?.querySelector('#maybe-you-meant-placeholder-drawer');
      if (container) {
        const loader = container.querySelector('.maybe-you-meant-loader');
        if (loader) {
          loader.remove();
        }
      }
    }
  
    highlightQueryInSuggestions(query) {
      const normalizedQuery = this.normalizeGreekText(query);
      const container = this.searchContent?.querySelector('#maybe-you-meant-placeholder');
      if (!container) return;
  
      const queryWords = normalizedQuery.split(/\s+/).filter(word => word.length > 2);
      if (queryWords.length === 0) return;
      
      const escapedWords = queryWords.map(word => word.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
      const regex = new RegExp(`\\b(${escapedWords.join('|')})\\b`, 'gi');
  
      const suggestionLinks = container.querySelectorAll('.maybe-you-meant-link span');
      suggestionLinks.forEach(span => {
        const text = span.textContent;
        const highlightedText = text.replace(regex, '<strong>$1</strong>');
        if (highlightedText !== text) {
          span.innerHTML = highlightedText;
        }
      });
    }
  }
  
  customElements.define('predictive-search-new', PredictiveSearchNew);
  
  
  
  class SearchDrawer extends HTMLElement {
    constructor() {
      super();
      
      this.cachedMap = new Map();
      this.abortController = new AbortController();
      this.searchContent = this.querySelector('.search__content');
      this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';
      this.searchInitialized = false;
      
      this.initializeSearch();
    }
  
    show() {
      this.classList.add('active');
      this.style.visibility = 'visible';
      document.body.classList.add('overflow-hidden');
      if (this.input) {
        setTimeout(() => this.input.focus(), 100);
      }
      
      if (this.searchContent) {
        this.searchContent.classList.remove('hidden');
        this.searchContent.style.display = '';
        this.searchContent.style.visibility = 'visible';
        this.searchContent.style.opacity = '1';
      }
      
      this.ensureCollectionsVisible();
      setTimeout(() => this.ensureCollectionsVisible(), 50);
      setTimeout(() => this.ensureCollectionsVisible(), 200);
      setTimeout(() => this.ensureCollectionsVisible(), 500);
    }
  
    hide() {
      this.classList.remove('active');
      this.style.visibility = 'hidden';
      document.body.classList.remove('overflow-hidden');
    }
  
    get focusElement() {
      return this.querySelector('input[type="search"]');
    }

    get input() {
      return this.querySelector('input[type="search"]');
    }

    get resetButton() {
      return this.querySelector('.reset__button');
    }
  
    initializeSearch() {
      if (this.searchInitialized) return;
      
      const form = this.querySelector('form');
      if (!form || !this.input) {
        setTimeout(() => this.initializeSearch(), 100);
        return;
      }
  
      this.searchInitialized = true;
      
      this.boundOnChange = debounce(this.onChange.bind(this), 300);
      this.boundOnFocus = this.onFocus.bind(this);
      this.boundClear = this.clear.bind(this);
      
      this.resetButton?.addEventListener('click', this.boundClear);
      
      if (this.input) {
        this.input.addEventListener('input', this.boundOnChange, { passive: true });
        this.input.addEventListener('keyup', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            const query = this.getQuery();
            if (query) {
              const normalizedValue = this.normalizeGreekText(query);
              const searchUrl = `${window.shopUrl || ''}/search?q=${encodeURIComponent(normalizedValue)}`;
              window.location.href = searchUrl;
            }
          } else if (e.key.length === 1 || e.key === 'Backspace' || e.key === 'Delete') {
            this.onChange();
          }
        });
        this.input.addEventListener('focus', this.boundOnFocus);
      }
  
      this.boundSubmit = (event) => {
        event.preventDefault();
        const searchInput = this.input;
        if (searchInput && searchInput.value) {
          const normalizedValue = this.normalizeGreekText(searchInput.value);
          if (searchInput.value !== normalizedValue) {
            searchInput.value = normalizedValue;
          }
          const searchUrl = `${window.shopUrl || ''}/search?q=${encodeURIComponent(normalizedValue)}`;
          window.location.href = searchUrl;
        }
      };
      
      form.addEventListener('submit', this.boundSubmit);
    }
  
    getQuery() {
      return this.input?.value?.trim() || '';
    }
  
    normalizeGreekText(text) {
      return text.toLowerCase().trim();
    }
  
    clear(event = null) {
      event && event.preventDefault();
      if (this.searchRecommendationEmpty && this.searchContent) {
        this.searchContent.classList.add('hidden');
      }
      if (this.input) {
        this.input.value = '';
        this.input.focus();
      }
      this.removeAttribute('results');
      const maybeBox = this.searchContent?.querySelector('#maybe-you-meant-placeholder');
      if (maybeBox) maybeBox.innerHTML = '';
      const fuzzyContainer = document.getElementById('predictive-fuzzy-results');
      if (fuzzyContainer) {
        fuzzyContainer.innerHTML = '';
        fuzzyContainer.style.display = 'none';
        fuzzyContainer.style.visibility = 'hidden';
        fuzzyContainer.style.opacity = '0';
      }
      const fuzzyHeading = document.querySelector('.predictive-search-result__heading');
      if (fuzzyHeading) {
        fuzzyHeading.remove();
      }
      
      const collectionsSection = this.querySelector('.predictive-search-result--collections');
      if (collectionsSection) {
        collectionsSection.style.display = 'block';
        collectionsSection.style.visibility = 'visible';
        collectionsSection.style.opacity = '1';
      }
    }
  
    setupURL() {
      const normalizedQuery = this.normalizeGreekText(this.getQuery());
      const url = new URL(`${window.shopUrl || ''}${routes.predictive_search_url}`);
      url.searchParams.set('q', normalizedQuery);
      url.searchParams.set('section_id', 'predictive-search');
      return url;
    }
  
    getSectionId() {
      return this.dataset.sectionId || 'predictive-search';
    }
  
    onFocus(event) {
      if (this.getQuery().length === 0) return;
      const url = this.setupURL().toString();
      this.renderSection(url, event);
    }
  
    onChange() {
      if (this.getQuery().length === 0) {
        this.clear();
        return;
      }
      
      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();
      
      const sectionId = this.getSectionId();
      const resultsId = 'PredictiveSearchResults-' + sectionId;
      const altResultsId = 'SearchDrawerResults-' + sectionId;
      
      const resultsContainer = document.getElementById(resultsId) || document.getElementById(altResultsId);
      if (resultsContainer) {
        resultsContainer.innerHTML = '';
      }
      
      const maybeBox = this.searchContent?.querySelector('#maybe-you-meant-placeholder');
      if (maybeBox) {
        maybeBox.remove();
      }
      
      const fuzzyContainer = document.getElementById('predictive-fuzzy-results');
      if (fuzzyContainer) {
        fuzzyContainer.innerHTML = '';
        fuzzyContainer.style.display = 'none';
        fuzzyContainer.style.visibility = 'hidden';
        fuzzyContainer.style.opacity = '0';
      }
      
      const fuzzyHeading = document.querySelector('.predictive-search-result__heading');
      if (fuzzyHeading) {
        fuzzyHeading.remove();
      }
      
      this.hideMainSearchLoader();
      this.hideFuzzyLoader();
      this.hideMaybeYouMeantLoader();
      
      const url = this.setupURL().toString();
      this.renderSection(url);
      const query = this.getQuery();
      if (query.length >= 1) {
        this.handleMaybeYouMeantPlaceholder(query).catch(err => {
          if (err.name !== 'AbortError') {
            console.error('Error handling maybe-you-meant placeholder:', err);
          }
        });
        this.fetchAndShowFuzzyResults(query).catch(err => {
          if (err.name !== 'AbortError') {
            console.error('Error fetching fuzzy results:', err);
          }
        });
      }
      
      this.ensureCollectionsVisible();
    }
    
    ensureCollectionsVisible() {
      const collectionsSection = this.querySelector('.predictive-search-result--collections');
      if (collectionsSection) {
        collectionsSection.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important;';
        collectionsSection.classList.remove('hidden');
        const list = collectionsSection.querySelector('#predictive-search-results-collection-list');
        if (list) {
          list.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important;';
          const items = list.querySelectorAll('li');
          items.forEach(item => {
            item.style.cssText = 'display: block !important; visibility: visible !important; border-bottom: 1px solid #e5e5e5; padding-bottom: 1rem; margin-bottom: 1rem;';
          });
        }
      }
      setTimeout(() => this.ensureCollectionsVisible(), 100);
      setTimeout(() => this.ensureCollectionsVisible(), 300);
    }
  
    async handleMaybeYouMeantPlaceholder(query) {
      const existingContainers = this.searchContent?.querySelectorAll('#maybe-you-meant-placeholder');
      if (existingContainers && existingContainers.length > 0) {
        existingContainers.forEach(container => container.remove());
      }
      
      let container = document.createElement('div');
      container.id = 'maybe-you-meant-placeholder';
  
      if (query.length < 1) {
        return;
      }
  
      // Show loader
      this.showMaybeYouMeantLoader();
  
      try {
        // Fetch products from GraphQL
        const graphqlQuery = {
          query: `
            query {
              products(first: 250) {
                edges {
                  node {
                    id
                    title
                    handle
                    featuredImage {
                      url
                      altText
                    }
                    variants(first: 250) {
                      edges {
                        node {
                          availableForSale
                        }
                      }
                    }
                  }
                }
              }
            }
          `
        };
  
        const res = await fetch("/api/2025-10/graphql.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": "c6d9974d72d77faac424c49c22f624c8"
          },
          body: JSON.stringify(graphqlQuery)
        });
  
        const json = await res.json();
        const allProducts = json?.data?.products?.edges?.map(e => e.node) || [];
  
        if (!allProducts.length) {
          this.hideMaybeYouMeantLoader();
          return;
        }
  
        const normalizedQuery = this.normalizeGreekText(query);
        const matches = allProducts
          .filter(product => {
            // First check if product is in stock
            if (!product.variants || !product.variants.edges || product.variants.edges.length === 0) {
              return false;
            }
            const variants = product.variants.edges.map(e => e.node);
            const isInStock = variants.some(v => v.availableForSale);
            if (!isInStock) {
              return false;
            }
            
            // Then check if it matches the query
            const productTitle = this.normalizeGreekText(product.title);
            const titleMatch = productTitle.includes(normalizedQuery);
            let tagsMatch = false;
            if (product.tags && Array.isArray(product.tags) && product.tags.length > 0) {
              const tagsText = product.tags.join(' ');
              const normalizedTags = this.normalizeGreekText(tagsText);
              tagsMatch = normalizedTags.includes(normalizedQuery);
            }
            return titleMatch || tagsMatch;
          })
          .slice(0, 10);
  
        // Create suggestion elements with actual products
        if (matches.length > 0) {
          const title = document.createElement('h4');
          title.textContent = 'Maybe you meant';
          title.className = 'h5 predictive-search-result__heading mb-3';
  
          const suggestionList = document.createElement('ul');
          suggestionList.className = 'predictive-search__maybe-you-meant';
  
          matches.forEach(product => {
            const li = document.createElement('li');
            li.className = 'maybe-you-meant-item';
            
            const link = document.createElement('a');
            link.href = `/products/${product.handle}`;
            link.className = 'reversed-link maybe-you-meant-link';
            link.style.display = 'flex';
            link.style.alignItems = 'center';
            link.style.gap = '12px';
            link.style.textDecoration = 'none';
            link.style.color = 'inherit';
            link.style.padding = '8px 12px';
            link.style.borderRadius = '4px';
            link.style.transition = 'transform 0.2s ease, opacity 0.2s ease';
            link.style.willChange = 'transform, opacity';
            link.style.position = 'relative';
            link.style.overflow = 'hidden';
            
            const hoverBg = document.createElement('span');
            hoverBg.style.position = 'absolute';
            hoverBg.style.top = '0';
            hoverBg.style.left = '0';
            hoverBg.style.right = '0';
            hoverBg.style.bottom = '0';
            hoverBg.style.backgroundColor = '#f5f5f5';
            hoverBg.style.opacity = '0';
            hoverBg.style.transition = 'opacity 0.2s ease';
            hoverBg.style.zIndex = '-1';
            hoverBg.style.borderRadius = 'inherit';
            link.appendChild(hoverBg);
            
            link.addEventListener('mouseenter', () => {
              hoverBg.style.opacity = '1';
              link.style.transform = 'translateX(2px)';
            });
            link.addEventListener('mouseleave', () => {
              hoverBg.style.opacity = '0';
              link.style.transform = 'translateX(0)';
            });
            
            // Create product image if available
            if (product.featuredImage && product.featuredImage.url) {
              const img = document.createElement('img');
              img.src = product.featuredImage.url;
              img.alt = product.featuredImage.altText || product.title;
              img.style.width = '40px';
              img.style.height = '40px';
              img.style.objectFit = 'cover';
              img.style.borderRadius = '4px';
              img.style.flexShrink = '0';
              link.appendChild(img);
            }
            
            // Create product title
            const textSpan = document.createElement('span');
            textSpan.textContent = product.title;
            link.appendChild(textSpan);
            
            li.appendChild(link);
            suggestionList.appendChild(li);
          });
  
          container.appendChild(title);
          container.appendChild(suggestionList);
          
          if (this.searchContent && !this.searchContent.contains(container)) {
            this.searchContent.appendChild(container);
          }
          
          // Highlight the original query in product titles
          if (typeof this.highlightQueryInSuggestions === 'function') {
            this.highlightQueryInSuggestions(query);
          }
        } else {
          // Show "no results" message
          const title = document.createElement('h4');
          title.textContent = 'Maybe you meant';
          title.className = 'h5 predictive-search-result__heading mb-3';
          
          const noResults = document.createElement('p');
          noResults.textContent = 'No products found';
          
          container.appendChild(title);
          container.appendChild(noResults);
          
          if (this.searchContent && !this.searchContent.contains(container)) {
            this.searchContent.appendChild(container);
          }
        }
  
      } catch (error) {
        console.error('Error fetching products for suggestions:', error);
        // Show error message
        const title = document.createElement('h4');
        title.textContent = 'Maybe you meant';
        title.className = 'h5 predictive-search-result__heading mb-3';
        
        const errorMsg = document.createElement('p');
        errorMsg.textContent = 'Error during search';
        
        container.appendChild(title);
        container.appendChild(errorMsg);
        
        if (this.searchContent && !this.searchContent.contains(container)) {
          this.searchContent.appendChild(container);
        }
      }
  
      this.hideMaybeYouMeantLoader();
    }
  
    renderSection(url) {
      this.cachedMap.has(url)
        ? this.renderSectionFromCache(url)
        : this.renderSectionFromFetch(url);
    }
  
    renderSectionFromCache(url) {
      const responseText = this.cachedMap.get(url);
      this.renderSearchResults(responseText);
      this.setAttribute('results', '');
    }
  
    renderSectionFromFetch(url) {
      this.setAttribute('loading', 'true');
      this.resetButton?.classList.add('btn--loading');
      
      this.showMainSearchLoader();
  
      if (!this.abortController) {
        this.abortController = new AbortController();
      }
  
      fetch(url, { signal: this.abortController.signal })
        .then((response) => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then((responseText) => {
          if (this.abortController && this.abortController.signal.aborted) return;
          this.renderSearchResults(responseText);
          this.cachedMap.set(url, responseText);
          this.hideMainSearchLoader();
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
          console.error('Error fetching data: ', error);
          this.setAttribute('error', 'Failed to load data');
          this.hideMainSearchLoader();
        })
        .finally(() => {
          if (this.abortController && this.abortController.signal.aborted) return;
          this.removeAttribute('loading');
          this.resetButton?.classList.remove('btn--loading');
          this.setAttribute('results', 'true');
        });
    }
  
    async renderSearchResults(responseText) {
      const sectionId = this.getSectionId();
      const id = 'PredictiveSearchResults-' + sectionId;
      let targetElement = document.getElementById(id);
      
      if (!targetElement) {
        const altId = 'SearchDrawerResults-' + sectionId;
        targetElement = document.getElementById(altId);
      }
  
      if (!targetElement) return;
  
      const fuzzyContainer = document.getElementById('predictive-fuzzy-results');
      const fuzzyContainerHTML = fuzzyContainer ? fuzzyContainer.outerHTML : '';
      
      const collectionsSection = targetElement.querySelector('.predictive-search-result--collections');
      const collectionsSectionHTML = collectionsSection ? collectionsSection.outerHTML : '';
  
      const parser = new DOMParser();
      const parsedDoc = parser.parseFromString(responseText, 'text/html');
      let contentElement = parsedDoc.getElementById(id);
      
      if (!contentElement) {
        const altId = 'SearchDrawerResults-' + sectionId;
        contentElement = parsedDoc.getElementById(altId);
      }
  
      if (contentElement) {
        this.searchContent?.classList.remove('hidden');
        targetElement.innerHTML = contentElement.innerHTML;
        
        if (collectionsSectionHTML) {
          const existingCollectionsSection = targetElement.querySelector('.predictive-search-result--collections');
          if (existingCollectionsSection) {
            existingCollectionsSection.outerHTML = collectionsSectionHTML;
          } else {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = collectionsSectionHTML;
            const restoredCollectionsSection = tempDiv.firstElementChild;
            if (restoredCollectionsSection) {
              restoredCollectionsSection.style.display = 'block';
              restoredCollectionsSection.style.visibility = 'visible';
              const productsSection = targetElement.querySelector('.predictive-search-result--products');
              if (productsSection && productsSection.nextSibling) {
                targetElement.insertBefore(restoredCollectionsSection, productsSection.nextSibling);
              } else {
                targetElement.appendChild(restoredCollectionsSection);
              }
            }
          }
        } else {
          const staticCollectionsSection = this.querySelector('.predictive-search-result--collections');
          if (staticCollectionsSection && !targetElement.querySelector('.predictive-search-result--collections')) {
            const clonedSection = staticCollectionsSection.cloneNode(true);
            clonedSection.style.display = 'block';
            clonedSection.style.visibility = 'visible';
            const productsSection = targetElement.querySelector('.predictive-search-result--products');
            if (productsSection && productsSection.nextSibling) {
              targetElement.insertBefore(clonedSection, productsSection.nextSibling);
            } else {
              targetElement.appendChild(clonedSection);
            }
          }
        }
        
        const finalCollectionsSection = targetElement.querySelector('.predictive-search-result--collections');
        if (finalCollectionsSection) {
          finalCollectionsSection.style.display = 'block';
          finalCollectionsSection.style.visibility = 'visible';
          finalCollectionsSection.style.opacity = '1';
          const list = finalCollectionsSection.querySelector('#predictive-search-results-collection-list');
          if (list) {
            list.style.display = 'block';
            list.style.visibility = 'visible';
            list.style.opacity = '1';
          }
          const heading = finalCollectionsSection.querySelector('.predictive-search-result__heading');
          if (heading) {
            heading.style.display = 'block';
            heading.style.visibility = 'visible';
          }
        }
        
        if (fuzzyContainerHTML && !targetElement.querySelector('#predictive-fuzzy-results')) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = fuzzyContainerHTML;
          const restoredFuzzyContainer = tempDiv.firstElementChild;
          if (restoredFuzzyContainer) {
            targetElement.insertBefore(restoredFuzzyContainer, targetElement.firstChild);
          }
        }
        
        const query = this.getQuery();
        if (query.length >= 1) {
          this.fetchAndShowFuzzyResults(query).catch(err => {
            console.error('Error fetching fuzzy results after render:', err);
          });
        }
        
        this.delegateAddToCartButtons();
        this.highlightMatches();

        if (query.length >= 1) {
          this.fetchAndSuggestSimilarProducts(query);
        } else {
          const maybeBox = this.searchContent?.querySelector('#maybe-you-meant-placeholder');
          if (maybeBox) maybeBox.innerHTML = '';
        }
      }
    }
  
    delegateAddToCartButtons() {
      this.searchContent
        ?.querySelectorAll(".predictive-search__add-button")
        .forEach((button) => {
          button.removeEventListener("click", this.handleAddToCartClick);
          button.addEventListener("click", this.handleAddToCartClick.bind(this));
        });
    }
  
    handleAddToCartClick(event) {
      event.preventDefault();
      const button = event.currentTarget;
      const productId = button.dataset.productId;
      const quantity = parseInt(button.dataset.quantity || "1", 10);
  
      if (!productId) return;
  
      const buttonText = button.querySelector('.button-text');
      const spinner = button.querySelector('.loading__spinner');
  
      button.classList.add("btn--loading");
      button.setAttribute("aria-disabled", "true");
      if (buttonText) buttonText.style.display = "none";
      if (spinner) spinner.classList.remove("hidden");
  
      const formData = new FormData();
      formData.set("id", productId);
      formData.set("quantity", quantity);
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:grouped-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );
      formData.append("sections", sectionsToBundle);
      formData.append("sections_url", window.location.pathname);
  
      const config = {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        },
        body: formData
      };
  
      fetch(routes.cart_add_url, config)
        .then((response) => response.json())
        .then(async (parsedState) => {
          if (parsedState.status) {
            const errorMessage = parsedState.description || "Error adding to cart";
            document.dispatchEvent(new CustomEvent("toast:show", {
              detail: { message: errorMessage }
            }));
            
            const errorDiv = button.closest('.product-card-2')?.querySelector('.product-form__error-message');
            if (errorDiv) {
              errorDiv.textContent = errorMessage;
              errorDiv.removeAttribute('hidden');
              setTimeout(() => {
                errorDiv.setAttribute('hidden', '');
              }, 2000);
            }
            return;
          }
  
          const cartJson = await (await fetch(routes.cart_url)).json();
          cartJson["sections"] = parsedState["sections"];
          document.dispatchEvent(new CustomEvent("cart:update", {
            detail: { cart: cartJson }
          }));
  
          document.dispatchEvent(new CustomEvent("toast:show", {
            detail: { message: `${parsedState.title || "Product"} added to cart` }
          }));
  
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer?.show) cartDrawer.show(button);
  
          // Hide search drawer after adding to cart
          this.hide();
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
          
          // Show error in error div
          const errorDiv = button.closest('.product-card-2').querySelector('.product-form__error-message');
          if (errorDiv) {
            errorDiv.textContent = "Network error occurred while adding to cart";
            errorDiv.removeAttribute('hidden');
            // Hide error after 2 seconds
            setTimeout(() => {
              errorDiv.setAttribute('hidden', '');
            }, 2000);
          }
        })
        .finally(() => {
          button.classList.remove("btn--loading");
          button.removeAttribute("aria-disabled");
          if (buttonText) buttonText.style.display = "";
          if (spinner) spinner.style.display = "none";
        });
    }
  
    async fetchAndSuggestSimilarProducts(query) {
      if (query.length < 1) {
        const maybeBox = this.searchContent?.querySelector('#maybe-you-meant-placeholder');
        if (maybeBox) maybeBox.innerHTML = '';
        return;
      }
  
      this.showMaybeYouMeantLoader();
  
      const graphqlQuery = {
        query: `
          query {
            products(first: 250) {
              edges {
                node {
                  id
                  title
                  handle
                  tags
                  featuredImage {
                    url
                    altText
                  }
                  variants(first: 250) {
                    edges {
                      node {
                        availableForSale
                      }
                    }
                  }
                }
              }
            }
          }
        `
      };
  
      try {
        const res = await fetch("/api/2025-10/graphql.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": "c6d9974d72d77faac424c49c22f624c8"
          },
          body: JSON.stringify(graphqlQuery)
        });
  
        const json = await res.json();
        const allProducts = json?.data?.products?.edges?.map(e => e.node) || [];
  
        if (!allProducts.length) {
          this.hideMaybeYouMeantLoader();
          return;
        }

        const availableProducts = allProducts.filter(product => {
          if (!product.variants || !product.variants.edges || product.variants.edges.length === 0) {
            return false;
          }
          const variants = product.variants.edges.map(e => e.node);
          return variants.some(v => v.availableForSale);
        });
  
        const matches = this.fuzzySearchTagFirst(availableProducts, query, "title").slice(0, 10);
        
        if (matches.length > 0) {
          this.renderMaybeYouMeant(matches);
        }
        this.hideMaybeYouMeantLoader();
      } catch (err) {
        console.error("Failed fuzzy suggestion:", err);
        this.hideMaybeYouMeantLoader();
      }
    }
  
    // Add collections search functionality to SearchDrawer
    async fetchAndSearchCollections(query) {
      const coreCollectionHandles = ['thca-flower', 'thca-ounces', 'thca-smalls', 'thca-gummies', 'thca-vape-carts', 'thca-concentrates', 'mushroom', 'thca-shake', 'thca-subscriptions'];
      
      const collectionQueries = coreCollectionHandles.map(handle => `
        ${handle.replace(/-/g, '_')}: collection(handle: "${handle}") {
          id
          title
          handle
          description
          image {
            url
            altText
          }
          products(first: 10) {
            edges {
              node {
                tags
              }
            }
          }
        }
      `).join('\n');

      const graphqlQuery = {
        query: `
          query {
            ${collectionQueries}
          }
        `
      };
  
      try {
        const res = await fetch("/api/2025-10/graphql.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": "c6d9974d72d77faac424c49c22f624c8"
          },
          body: JSON.stringify(graphqlQuery)
        });
  
        const json = await res.json();
        const data = json?.data || {};
        
        const coreCollections = coreCollectionHandles
          .map(handle => {
            const key = handle.replace(/-/g, '_');
            return data[key] || null;
          })
          .filter(collection => collection !== null);
  
        return coreCollections;
      } catch (err) {
        console.error("Failed collections search:", err);
        return [];
      }
    }
  
    // Fuzzy search specifically for collections in SearchDrawer with improved 99% matching
    fuzzySearchCollections(collections, query, key) {
      function normalizeText(str) {
        return this.normalizeGreekText(str);
      }
  
      const queryNormalized = normalizeText.call(this, query);
      const queryWords = queryNormalized.split(/\s+/).filter(word => word.length > 0);
      
      if (queryNormalized.length < 1) {
        return [];
      }
      
      const calculateFieldScore = (text, isTag = false) => {
        if (!text) return 0;
        const textNormalized = normalizeText.call(this, text);
        let score = 0;
        let exactMatchBonus = 0;
        let wordMatchBonus = 0;
        let consecutiveMatchBonus = 0;
        let startMatchBonus = 0;
        let characterMatchBonus = 0;
        
        const queryCharsForMatch = queryNormalized.split('');
        const textCharsForMatch = textNormalized.split('');
        
        let charMatches = 0;
        for (const char of queryCharsForMatch) {
          if (textCharsForMatch.includes(char)) {
            charMatches++;
          }
        }
        
        if (charMatches === 0) {
          return 0;
        }
        
        characterMatchBonus = (charMatches / queryCharsForMatch.length) * (isTag ? 8 : 10);
        
        if (textNormalized.includes(queryNormalized)) {
          exactMatchBonus = isTag ? 25 : 30;
        }
        
        let matchedWords = 0;
        for (const word of queryWords) {
          if (textNormalized.includes(word)) {
            matchedWords++;
            wordMatchBonus += isTag ? Math.max(6, word.length * 1.5) : Math.max(8, word.length * 2);
          }
        }
        
        const queryChars = queryNormalized.split('');
        let consecutiveCount = 0;
        let maxConsecutive = 0;
        let queryIndex = 0;
        
        for (let i = 0; i < textNormalized.length && queryIndex < queryChars.length; i++) {
          if (textNormalized[i] === queryChars[queryIndex]) {
            consecutiveCount++;
            queryIndex++;
          } else {
            if (consecutiveCount > maxConsecutive) {
              maxConsecutive = consecutiveCount;
            }
            consecutiveCount = 0;
          }
        }
        
        if (consecutiveCount > maxConsecutive) {
          maxConsecutive = consecutiveCount;
        }
        
        consecutiveMatchBonus = maxConsecutive / queryChars.length * (isTag ? 8 : 10);
        
        if (textNormalized.startsWith(queryNormalized)) {
          startMatchBonus = isTag ? 15 : 20;
        }
        
        score = exactMatchBonus + wordMatchBonus + consecutiveMatchBonus + startMatchBonus + characterMatchBonus;
        return score;
      };
      
      return collections
        .map(collection => {
          const titleScore = calculateFieldScore(collection[key] || collection.title, false);
          
          let tagsScore = 0;
          if (collection.products && collection.products.edges && collection.products.edges.length > 0) {
            const allTags = [];
            collection.products.edges.forEach(edge => {
              if (edge.node && edge.node.tags && Array.isArray(edge.node.tags)) {
                allTags.push(...edge.node.tags);
              }
            });
            if (allTags.length > 0) {
              const uniqueTags = [...new Set(allTags)];
              const tagsText = uniqueTags.join(' ');
              tagsScore = calculateFieldScore(tagsText, true);
            }
          }
          
          const totalScore = titleScore + tagsScore;
          
          if (totalScore === 0) {
            return {
              item: collection,
              score: 0,
              exactMatch: false,
              wordMatches: 0,
              consecutiveScore: 0,
              startMatch: false
            };
          }
          
          const textNormalized = normalizeText.call(this, collection[key] || collection.title);
          let hasExactMatch = textNormalized.includes(queryNormalized);
          let hasStartMatch = textNormalized.startsWith(queryNormalized);
          let hasTagMatch = false;
          
          if (collection.products && collection.products.edges) {
            const allTags = [];
            collection.products.edges.forEach(edge => {
              if (edge.node && edge.node.tags && Array.isArray(edge.node.tags)) {
                allTags.push(...edge.node.tags);
              }
            });
            if (allTags.length > 0) {
              const tagsText = allTags.join(' ');
              const tagsNormalized = normalizeText.call(this, tagsText);
              if (tagsNormalized.includes(queryNormalized)) {
                hasExactMatch = true;
                hasTagMatch = true;
              }
              if (!hasTagMatch) {
                hasTagMatch = allTags.some(tag => {
                  const tagNormalized = normalizeText.call(this, tag);
                  return tagNormalized.includes(queryNormalized) || queryWords.some(word => tagNormalized.includes(word));
                });
              }
            }
          }
          
          let matchedWords = 0;
          for (const word of queryWords) {
            if (textNormalized.includes(word)) {
              matchedWords++;
            } else if (collection.products && collection.products.edges) {
              const allTags = [];
              collection.products.edges.forEach(edge => {
                if (edge.node && edge.node.tags && Array.isArray(edge.node.tags)) {
                  allTags.push(...edge.node.tags);
                }
              });
              if (allTags.some(tag => normalizeText.call(this, tag).includes(word))) {
                matchedWords++;
              }
            }
          }
          
          const finalScore = totalScore + Math.min((collection.products?.totalCount || 0) / 20, 2);
          
          return {
            item: collection,
            score: finalScore,
            exactMatch: hasExactMatch,
            wordMatches: matchedWords,
            consecutiveScore: 0,
            startMatch: hasStartMatch,
            semanticMatch: false,
            hasTagMatch: hasTagMatch || false,
          };
        })
        .filter(result => result.score >= 0.1)
        .sort((a, b) => {
          if (b.hasTagMatch !== a.hasTagMatch) {
            return b.hasTagMatch ? -1 : 1;
          }
          if (b.score !== a.score) {
            return b.score - a.score;
          }
          if (b.exactMatch !== a.exactMatch) {
            return b.exactMatch ? -1 : 1;
          }
          if (b.startMatch !== a.startMatch) {
            return b.startMatch ? -1 : 1;
          }
          if (b.wordMatches !== a.wordMatches) {
            return b.wordMatches - a.wordMatches;
          }
          return b.consecutiveScore - a.consecutiveScore;
        })
        .map(result => result.item);
    }
  
    // Dynamic Greek word suggestion generator
    generateGreekSuggestions(query) {
      const normalizedQuery = this.normalizeGreekText(query);
      const suggestions = [];
      
      // Greek character variations for dynamic suggestions
      const greekCharVariations = {
        'α': ['ά', 'α', 'Α', 'Ά'],
        'ε': ['έ', 'ε', 'Ε', 'Έ'],
        'η': ['ή', 'η', 'Η', 'Ή'],
        'ι': ['ί', 'ι', 'ϊ', 'ΐ', 'Ι', 'Ί', 'Ϊ'],
        'ο': ['ό', 'ο', 'Ο', 'Ό'],
        'υ': ['ύ', 'υ', 'ϋ', 'ΰ', 'Υ', 'Ύ', 'Ϋ'],
        'ω': ['ώ', 'ω', 'Ω', 'Ώ']
      };
      
      // Common Greek word endings and prefixes
      const commonEndings = ['ος', 'ης', 'ας', 'ες', 'ια', 'ιο', 'ου', 'ων'];
      const commonPrefixes = ['αυτ', 'παρ', 'υπερ', 'υπο', 'αντι', 'προ'];
      
      // Generate variations based on character substitutions
      const generateVariations = (word) => {
        const variations = [word];
        
        // Try different character combinations
        for (let i = 0; i < word.length; i++) {
          const char = word[i];
          const charVariations = greekCharVariations[char] || [char];
          
          for (const variation of charVariations) {
            const newWord = word.substring(0, i) + variation + word.substring(i + 1);
            if (newWord !== word) {
              variations.push(newWord);
            }
          }
        }
        
        return variations;
      };
      
      // Generate suggestions based on the query
      if (normalizedQuery.length >= 3) {
        // Add character variations
        suggestions.push(...generateVariations(normalizedQuery));
        
        // Add common endings
        for (const ending of commonEndings) {
          if (!normalizedQuery.endsWith(ending)) {
            suggestions.push(normalizedQuery + ending);
          }
        }
        
        // Add common prefixes
        for (const prefix of commonPrefixes) {
          if (!normalizedQuery.startsWith(prefix)) {
            suggestions.push(prefix + normalizedQuery);
          }
        }
        
        // Generate phonetic variations
        const phoneticMap = {
          'β': 'v', 'γ': 'g', 'δ': 'd', 'θ': 'th', 'κ': 'k', 'λ': 'l',
          'μ': 'm', 'ν': 'n', 'ξ': 'x', 'π': 'p', 'ρ': 'r', 'σ': 's',
          'τ': 't', 'φ': 'f', 'χ': 'ch', 'ψ': 'ps'
        };
        
        // Create phonetic variations
        let phoneticQuery = normalizedQuery;
        for (const [greek, latin] of Object.entries(phoneticMap)) {
          phoneticQuery = phoneticQuery.replace(new RegExp(greek, 'g'), latin);
        }
        if (phoneticQuery !== normalizedQuery) {
          suggestions.push(phoneticQuery);
        }
      }
      
      return [...new Set(suggestions)].slice(0, 10);
    }
  
    fuzzySearchTagFirst(products, query, key) {
      function normalizeText(str) {
        return this.normalizeGreekText(str);
      }

      const queryNormalized = normalizeText.call(this, query);
      const queryWords = queryNormalized.split(/\s+/).filter(word => word.length > 0);
      
      if (queryNormalized.length < 1) {
        return [];
      }

      const tagMatches = products.filter(product => {
        if (!product.tags || !Array.isArray(product.tags) || product.tags.length === 0) {
          return false;
        }
        return product.tags.some(tag => {
          const tagNormalized = normalizeText.call(this, tag);
          return tagNormalized.includes(queryNormalized) || queryWords.some(word => tagNormalized.includes(word));
        });
      });

      if (tagMatches.length > 0) {
        return this.fuzzySearch(tagMatches, query, key);
      }

      const titleMatches = products.filter(product => {
        const textNormalized = normalizeText.call(this, product[key] || product.title);
        return textNormalized.includes(queryNormalized) || queryWords.some(word => textNormalized.includes(word));
      });

      if (titleMatches.length > 0) {
        return this.fuzzySearch(titleMatches, query, key);
      }

      return [];
    }

    // Enhanced fuzzy search function with better scoring and sorting
    fuzzySearch(products, query, key) {
      function normalizeText(str) {
        return this.normalizeGreekText(str);
      }

      const queryNormalized = normalizeText.call(this, query);
      const queryWords = queryNormalized.split(/\s+/).filter(word => word.length > 0);
      
      if (queryNormalized.length < 1) {
        return [];
      }
      
      
      return products
        .map(product => {
          const textNormalized = normalizeText.call(this, product[key]);
          let totalScore = 0;
          let exactMatchBonus = 0;
          let wordMatchBonus = 0;
          let consecutiveMatchBonus = 0;
          let startMatchBonus = 0;
          let minimumMatchBonus = 0;
          let tagsScore = 0;
          
          const hasTagMatch = product.tags && product.tags.some(tag => {
            const tagNormalized = normalizeText.call(this, tag);
            return tagNormalized.includes(queryNormalized) || queryWords.some(word => tagNormalized.includes(word));
          });
          
          if (hasTagMatch && product.tags && Array.isArray(product.tags) && product.tags.length > 0) {
            for (const tag of product.tags) {
              const tagNormalized = normalizeText.call(this, tag);
              if (tagNormalized.includes(queryNormalized)) {
                tagsScore += 50;
              } else {
                for (const word of queryWords) {
                  if (tagNormalized.includes(word)) {
                    tagsScore += Math.max(10, word.length * 2);
                  }
                }
              }
            }
          }
          
          let hasMinimumMatch = false;
          if (queryNormalized.length >= 1) {
            for (let i = 0; i <= textNormalized.length - queryNormalized.length; i++) {
              const substring = textNormalized.substring(i, i + queryNormalized.length);
              if (substring === queryNormalized) {
                hasMinimumMatch = true;
                minimumMatchBonus = 5;
                break;
              }
            }
          }
          
          if (!hasMinimumMatch && queryNormalized.length > 0) {
            const queryChars = queryNormalized.split('');
            const textChars = textNormalized.split('');
            const matchingChars = queryChars.filter(char => textChars.includes(char));
            if (matchingChars.length === 0 && !hasTagMatch) {
              return {
                item: product,
                score: 0,
                exactMatch: false,
                wordMatches: 0,
                consecutiveScore: 0,
                startMatch: false,
                hasTagMatch: false,
              };
            }
            minimumMatchBonus = 2;
          }
          
          if (textNormalized.includes(queryNormalized)) {
            exactMatchBonus = 25;
          } else if (hasTagMatch && product.tags && product.tags.some(tag => normalizeText.call(this, tag).includes(queryNormalized))) {
            exactMatchBonus = 25;
          }
          
          let matchedWords = 0;
          for (const word of queryWords) {
            if (textNormalized.includes(word)) {
              matchedWords++;
              wordMatchBonus += Math.max(6, word.length * 1.5);
            } else if (hasTagMatch && product.tags && product.tags.some(tag => normalizeText.call(this, tag).includes(word))) {
              matchedWords++;
              wordMatchBonus += Math.max(6, word.length * 1.5);
            }
          }
          
          if (matchedWords > 1) {
            wordMatchBonus += matchedWords * 2;
          }
          
          const queryChars = queryNormalized.split('');
          let consecutiveCount = 0;
          let maxConsecutive = 0;
          let queryIndex = 0;
          
          for (let i = 0; i < textNormalized.length && queryIndex < queryChars.length; i++) {
            if (textNormalized[i] === queryChars[queryIndex]) {
              consecutiveCount++;
              queryIndex++;
            } else {
              if (consecutiveCount > maxConsecutive) {
                maxConsecutive = consecutiveCount;
              }
              consecutiveCount = 0;
            }
          }
          
          if (consecutiveCount > maxConsecutive) {
            maxConsecutive = consecutiveCount;
          }
          
          consecutiveMatchBonus = maxConsecutive / queryChars.length * 8;
          
          if (textNormalized.startsWith(queryNormalized)) {
            startMatchBonus = 15;
          }
          
          totalScore = tagsScore + exactMatchBonus + wordMatchBonus + consecutiveMatchBonus + startMatchBonus + minimumMatchBonus;
          
          const lengthBonus = Math.max(0, (50 - textNormalized.length) / 50);
          totalScore += lengthBonus;
          
          if (matchedWords > 1) {
            totalScore += matchedWords * 3;
          }
          
          if (queryNormalized.length > 10 && matchedWords > 0) {
            totalScore += 5;
          }
          
          return {
            item: product,
            score: totalScore,
            exactMatch: exactMatchBonus > 0,
            wordMatches: matchedWords,
            consecutiveScore: consecutiveMatchBonus,
            startMatch: startMatchBonus > 0,
            hasTagMatch: hasTagMatch || false,
          };
        })
        .filter(result => {
          return result.score >= 3;
        }) // Lower threshold for more inclusive matching
        .sort((a, b) => {
          // Primary sort by tag match
          if (b.hasTagMatch !== a.hasTagMatch) {
            return b.hasTagMatch ? -1 : 1;
          }
          // Secondary sort by total score
          if (b.score !== a.score) {
            return b.score - a.score;
          }
          // Tertiary sort by exact match
          if (b.exactMatch !== a.exactMatch) {
            return b.exactMatch ? -1 : 1;
          }
          // Quaternary sort by start match
          if (b.startMatch !== a.startMatch) {
            return b.startMatch ? -1 : 1;
          }
          // Quinary sort by word matches
          if (b.wordMatches !== a.wordMatches) {
            return b.wordMatches - a.wordMatches;
          }
          // Senary sort by consecutive score
          return b.consecutiveScore - a.consecutiveScore;
        })
        .map(result => result.item);
    }
  
    renderMaybeYouMeant(products) {
      let container = this.searchContent?.querySelector('#maybe-you-meant-placeholder-drawer');
      if (!container) {
        container = document.createElement('div');
        container.id = 'maybe-you-meant-placeholder-drawer';
        this.searchContent?.appendChild(container);
      }
      
      const list = document.createElement('ul');
      list.className = 'predictive-search__maybe-you-meant';
  
      const title = document.createElement('h4');
      title.textContent = 'Maybe you meant';
      title.className = 'h5 predictive-search-result__heading mb-3';
  
      products.forEach(p => {
        const li = document.createElement('li');
        li.className = 'maybe-you-meant-item';
        const pcard = document.createElement('p');
  
        const link = document.createElement('a');
        link.href = `/products/${p.handle}`;
        link.className = 'reversed-link maybe-you-meant-link';
        link.style.display = 'flex';
        link.style.alignItems = 'center';
        link.style.gap = '12px';
        link.style.textDecoration = 'none';
        link.style.color = 'inherit';
        
        // Create image element
        if (p.featuredImage && p.featuredImage.url) {
          const img = document.createElement('img');
          img.src = p.featuredImage.url;
          img.alt = p.featuredImage.altText || p.title;
          img.style.width = '60px';
          img.style.height = '60px';
          img.style.objectFit = 'cover';
          img.style.borderRadius = '4px';
          img.style.flexShrink = '0';
          li.appendChild(img);
        }
        
        // Create text container
        link.textContent = p.title;
        pcard.appendChild(link);
        li.appendChild(pcard);
        list.appendChild(li);
      });
      
      container.innerHTML = '';
      container.appendChild(title);
      container.appendChild(list);
      // Highlight matches in maybe-you-meant links
      this.highlightMaybeYouMeantMatches();
    }
  
    highlightMaybeYouMeantMatches() {
      const query = this.getQuery();
      if (!query || !this.searchContent) return;
      
      // Create normalized query for better matching
      const normalizedQuery = this.normalizeGreekText(query);
      const queryWords = normalizedQuery.split(/\s+/).filter(word => word.length > 2);
      if (queryWords.length === 0) return;
      
      const escapedWords = queryWords.map(word => word.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
      const regex = new RegExp(`\\b(${escapedWords.join('|')})\\b`, 'gi');
      const highlightTextNodes = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const replaced = node.textContent.replace(regex, '<strong>$1</strong>');
          if (replaced !== node.textContent) {
            const span = document.createElement('span');
            span.innerHTML = replaced;
            node.replaceWith(...span.childNodes);
          }
        } else if (node.nodeType === Node.ELEMENT_NODE && node.childNodes.length > 0) {
          node.childNodes.forEach(highlightTextNodes);
        }
      };
      
      this.searchContent.querySelectorAll('.maybe-you-meant-link').forEach(highlightTextNodes);
    }
  
    highlightMatches() {
      const query = this.getQuery();
      if (!query || !this.searchContent) return;
  
      // Create normalized query for better matching
      const normalizedQuery = this.normalizeGreekText(query);
      const queryWords = normalizedQuery.split(/\s+/).filter(word => word.length > 2);
      if (queryWords.length === 0) return;
  
      const escapedWords = queryWords.map(word => word.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
      const regex = new RegExp(`\\b(${escapedWords.join('|')})\\b`, 'gi');
      const highlightTextNodes = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const replaced = node.textContent.replace(regex, '<strong>$1</strong>');
          if (replaced !== node.textContent) {
            const span = document.createElement('span');
            span.innerHTML = replaced;
            node.replaceWith(...span.childNodes);
          }
        } else if (node.nodeType === Node.ELEMENT_NODE && node.childNodes.length > 0) {
          node.childNodes.forEach(highlightTextNodes);
        }
      };
      this.searchContent.querySelectorAll('.reversed-link').forEach(highlightTextNodes);
    }
  
    trapFocus(element) {
      if (element && typeof element.focus === 'function') {
        element.focus();
      }
    }
  
    showMaybeYouMeantLoader() {
      let container = this.searchContent?.querySelector('#maybe-you-meant-placeholder-drawer');
      if (!container) {
        container = document.createElement('div');
        container.id = 'maybe-you-meant-placeholder-drawer';
        this.searchContent?.appendChild(container);
      }
      
      container.innerHTML = `
        <div class="maybe-you-meant-loader" style="display: flex; justify-content: center; align-items: center; padding: 20px;">
          <div class="loading__spinner">
            <svg aria-hidden="true" focusable="false" class="spinner icon icon--medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </div>
      `;
    }
  
    hideMaybeYouMeantLoader() {
      const container = this.searchContent?.querySelector('#maybe-you-meant-placeholder-drawer');
      if (container) {
        const loader = container.querySelector('.maybe-you-meant-loader');
        if (loader) {
          loader.remove();
        }
      }
    }
  
    showMainSearchLoader() {
      if (!this.searchContent) return;
      
      const existingLoader = this.searchContent.querySelector('.main-search-loader');
      if (existingLoader) {
        existingLoader.remove();
      }
      
      if (!document.querySelector('#main-search-loader-style-drawer')) {
        const style = document.createElement('style');
        style.id = 'main-search-loader-style-drawer';
        style.textContent = `
          .main-search-loader .spinner {
            animation: mainSearchRotate 1.4s linear infinite;
          }
          .main-search-loader .path {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: 0;
            stroke-linecap: round;
            stroke: currentColor;
            animation: mainSearchDash 1.4s ease-in-out infinite;
          }
          @keyframes mainSearchRotate {
            100% { transform: rotate(360deg); }
          }
          @keyframes mainSearchDash {
            0% {
              stroke-dasharray: 1, 150;
              stroke-dashoffset: 0;
            }
            50% {
              stroke-dasharray: 90, 150;
              stroke-dashoffset: -35;
            }
            100% {
              stroke-dasharray: 90, 150;
              stroke-dashoffset: -124;
            }
          }
        `;
        document.head.appendChild(style);
      }
      
      const loaderDiv = document.createElement('div');
      loaderDiv.className = 'main-search-loader';
      loaderDiv.style.cssText = `
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        margin: 10px 0;
      `;
      
      loaderDiv.innerHTML = `
        <div class="loading__spinner" style="width: 40px; height: 40px; color: #666;">
          <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width: 100%; height: 100%;">
            <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
      `;
      
      this.searchContent.insertBefore(loaderDiv, this.searchContent.firstChild);
    }
  
    hideMainSearchLoader() {
      if (!this.searchContent) return;
      
      const loader = this.searchContent.querySelector('.main-search-loader');
      if (loader) {
        loader.remove();
      }
    }
  
    // Update collections section with dynamic results for SearchDrawer
    updateCollectionsSection(collections) {
      return;
      const collectionsSection = this.searchContent?.querySelector('.predictive-search-result--collections');
      if (!collectionsSection) {
        return;
      }
  
      const heading = collectionsSection.querySelector('.predictive-search-result__heading');
      const list = collectionsSection.querySelector('#predictive-search-results-collection-list');
      const noDataMessage = collectionsSection.querySelector('p');
      
      if (collections.length > 0) {
        // Update heading with count
        if (heading) {
          heading.textContent = `Categories (${collections.length})`;
        }
  
        // Create new list items
        if (list) {
          list.innerHTML = '';
          collections.forEach((collection, index) => {
            const li = document.createElement('li');
            li.id = `predictive-search-option-collection-${index + 1}`;
            li.className = 'predictive-search__list-item';
            li.setAttribute('role', 'option');
            li.setAttribute('aria-selected', 'false');
            li.style.cssText = 'border-bottom: 1px solid #e5e5e5; padding-bottom: 1rem; margin-bottom: 1rem;';
  
            const link = document.createElement('a');
            link.href = `/collections/${collection.handle}`;
            link.className = 'reversed-link';
            link.textContent = collection.title;
            
            li.appendChild(link);
            list.appendChild(li);
          });
          
        } else {
          // Create the list if it doesn't exist
          const newList = document.createElement('ul');
          newList.id = 'predictive-search-results-collection-list';
          newList.className = 'predictive-search-result__list';
          newList.setAttribute('role', 'group');
          newList.setAttribute('aria-labelledby', 'predictive-search-collection');
          
          collections.forEach((collection, index) => {
            const li = document.createElement('li');
            li.id = `predictive-search-option-collection-${index + 1}`;
            li.className = 'predictive-search__list-item';
            li.setAttribute('role', 'option');
            li.setAttribute('aria-selected', 'false');
            li.style.cssText = 'border-bottom: 1px solid #e5e5e5; padding-bottom: 1rem; margin-bottom: 1rem;';
  
            const link = document.createElement('a');
            link.href = `/collections/${collection.handle}`;
            link.className = 'reversed-link';
            link.textContent = collection.title;
            
            li.appendChild(link);
            newList.appendChild(li);
          });
          
          collectionsSection.appendChild(newList);
        }
  
        // Hide no data message if it exists
        if (noDataMessage) {
          noDataMessage.style.display = 'none';
        }
      } else {
        // Show no data message
        if (heading) {
          heading.textContent = 'Categories (0)';
        }
        
        if (list) {
          list.innerHTML = '';
        }
        
        if (noDataMessage) {
          noDataMessage.style.display = 'block';
          noDataMessage.textContent = 'No Categories found';
        } else {
          // Create no data message if it doesn't exist
          const newNoDataMessage = document.createElement('p');
          newNoDataMessage.textContent = 'No Categories found';
          collectionsSection.appendChild(newNoDataMessage);
        }
      }
  
      // Highlight matches in collection links
      this.highlightCollectionMatches();
    }
  
    highlightCollectionMatches() {
      return;
    }
  
    // Add displayFuzzyResults method to SearchDrawer class
    displayFuzzyResults(products) {
      let container = document.getElementById('predictive-fuzzy-results');
      if (!container) {
        container = document.createElement('div');
        container.id = 'predictive-fuzzy-results';
        if (this.searchContent) {
          const resultsBox = this.searchContent.querySelector('.search__results') || this.searchContent.querySelector('.search__box');
          if (resultsBox) {
            resultsBox.appendChild(container);
          } else {
            this.searchContent.appendChild(container);
          }
        } else {
          const searchResults = document.querySelector('[id^="PredictiveSearchResults"]');
          if (searchResults) {
            searchResults.appendChild(container);
          } else {
            document.body.appendChild(container);
          }
        }
      }
      
      container.style.display = 'grid';
      container.style.visibility = 'visible';
      container.style.opacity = '1';
      
      if (this.searchContent) {
        this.searchContent.classList.remove('hidden');
        this.searchContent.style.display = '';
      }
      
      // Hide the 'No popular searches found' message if fuzzy results exist
      const noPopularMsg = document.querySelector('.no-data-found');
      if (noPopularMsg && products.length > 0) {
        noPopularMsg.style.display = 'none';
      }
      
      if (container.parentNode) {
        const existingHeading = container.parentNode.querySelector('.predictive-search-result__heading');
        if (existingHeading) {
          existingHeading.remove();
        }
      }
      
      container.innerHTML = '';
      
      if (!products.length) {
        const noResultsDiv = document.createElement('p');
        noResultsDiv.className = 'no-fuzzy-results-found';
        noResultsDiv.style.cssText = 'text-align: center; padding: 20px;';
        noResultsDiv.textContent = 'No results found';
        container.appendChild(noResultsDiv);
        return;
      }
      
      const heading = document.createElement('h4');
      heading.className = 'h5 predictive-search-result__heading';
      heading.textContent = `Products (${products.length})`;
      heading.style.marginBottom = '1rem';
      if (container.parentNode) {
        container.parentNode.insertBefore(heading, container);
      }
      
      const list = document.createElement('ul');
      list.className = 'predictive-search__fuzzy-results grid gap-4';
      
      products.forEach((p, idx) => {
        const li = document.createElement('li');
        li.id = `predictive-fuzzy-result-product-${idx+1}`;
        li.className = 'predictive-search__list-item product-card-2';
        li.setAttribute('role', 'option');
        li.style.cssText = 'border-bottom: 1px solid #e5e5e5; padding-bottom: 1rem; margin-bottom: 1rem;';
  
        const flexDiv = document.createElement('div');
        flexDiv.className = 'flex gap-6 items-center';
        flexDiv.style.width = '100%';
  
        // Image
        if (p.featuredImage && p.featuredImage.url) {
          const aImg = document.createElement('a');
          aImg.href = `/products/${p.handle}`;
          aImg.className = 'media-wrapper blocks-radius-sm';
          const img = document.createElement('img');
          img.src = p.featuredImage.url;
          img.alt = p.featuredImage.altText || p.title;
          img.loading = 'lazy';
          img.width = 100;
          img.height = 100;
          img.style.objectFit = 'cover';
          img.style.borderRadius = '4px';
          aImg.appendChild(img);
          flexDiv.appendChild(aImg);
        }
  
        // Info
        const infoDiv = document.createElement('div');
        infoDiv.className = 'grid gap-1';
        infoDiv.style.flex = '1';
  
  
        // Title
        const pTitle = document.createElement('p');
        pTitle.className = 'block m-0';
        const aTitle = document.createElement('a');
        aTitle.href = `/products/${p.handle}`;
        aTitle.className = 'reversed-link text-pcard-title fuzzy-result-link';
        aTitle.textContent = p.title;
        pTitle.appendChild(aTitle);
        infoDiv.appendChild(pTitle);
  
        // Price (if available)
        if (p.priceRange && p.priceRange.minVariantPrice) {
          const priceDiv = document.createElement('div');
          priceDiv.className = 'text-price';
          const minPrice = parseFloat(p.priceRange.minVariantPrice.amount);
          const maxPrice = parseFloat(p.priceRange.maxVariantPrice.amount);
          const currencyCode = p.priceRange.minVariantPrice.currencyCode;
          let formattedPrice = '';
          
          if (minPrice === maxPrice) {
            formattedPrice = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: currencyCode,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(minPrice);
          } else {
            const formattedMin = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: currencyCode,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(minPrice);
            const formattedMax = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: currencyCode,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(maxPrice);
            formattedPrice = `${formattedMin} - ${formattedMax}`;
          }
          
          priceDiv.textContent = formattedPrice;
          infoDiv.appendChild(priceDiv);
        }
  
        flexDiv.appendChild(infoDiv);
  
        li.appendChild(flexDiv);
        list.appendChild(li);
      });
      
      container.appendChild(list);
      
      // Delegate add to cart buttons
      this.delegateAddToCartButtons();
      
      // Highlight matches
      this.highlightFuzzyMatches();
    }

    displayAllFuzzyResults(products, collections, pages) {
      let container = document.getElementById('predictive-fuzzy-results');
      if (!container) {
        container = document.createElement('div');
        container.id = 'predictive-fuzzy-results';
        if (this.searchContent) {
          const resultsBox = this.searchContent.querySelector('.search__results') || this.searchContent.querySelector('.search__box');
          if (resultsBox) {
            resultsBox.appendChild(container);
          } else {
            this.searchContent.appendChild(container);
          }
        } else {
          const searchResults = document.querySelector('[id^="PredictiveSearchResults"]');
          if (searchResults) {
            searchResults.appendChild(container);
          } else {
            document.body.appendChild(container);
          }
        }
      }
      
      container.style.display = 'grid';
      container.style.visibility = 'visible';
      container.style.opacity = '1';
      
      if (this.searchContent) {
        this.searchContent.classList.remove('hidden');
        this.searchContent.style.display = '';
      }
      
      const noPopularMsg = document.querySelector('.no-data-found');
      if (noPopularMsg && (products.length > 0 || pages.length > 0)) {
        noPopularMsg.style.display = 'none';
      }
      if (container.parentNode) {
        const existingHeading = container.parentNode.querySelector('.predictive-search-result__heading');
        if (existingHeading) {
          existingHeading.remove();
        }
      }
      
      container.innerHTML = '';
      
      const totalResults = products.length + pages.length;
      if (totalResults === 0) {
        const noResultsDiv = document.createElement('p');
        noResultsDiv.className = 'no-fuzzy-results-found';
        noResultsDiv.style.cssText = 'text-align: center; padding: 20px;';
        noResultsDiv.textContent = 'No results found';
        container.appendChild(noResultsDiv);
        return;
      }

      if (products.length > 0) {
        const limitedProducts = products.slice(0, 15);
        const heading = document.createElement('h4');
        heading.className = 'h5 predictive-search-result__heading';
        heading.textContent = `Products (${limitedProducts.length})`;
        heading.style.marginBottom = '1rem';
        if (container.parentNode) {
          container.parentNode.insertBefore(heading, container);
        }
        
        const list = document.createElement('ul');
        list.className = 'predictive-search__fuzzy-results grid gap-4';
        
        limitedProducts.forEach((p, idx) => {
          const li = document.createElement('li');
          li.id = `predictive-fuzzy-result-product-${idx+1}`;
          li.className = 'predictive-search__list-item product-card-2';
          li.setAttribute('role', 'option');
          li.style.cssText = 'border-bottom: 1px solid #e5e5e5; padding-bottom: 1rem; margin-bottom: 1rem;';
    
          const flexDiv = document.createElement('div');
          flexDiv.className = 'flex gap-6 items-center';
          flexDiv.style.width = '100%';
    
          if (p.featuredImage && p.featuredImage.url) {
            const aImg = document.createElement('a');
            aImg.href = `/products/${p.handle}`;
            aImg.className = 'media-wrapper blocks-radius-sm';
            const img = document.createElement('img');
            img.src = p.featuredImage.url;
            img.alt = p.featuredImage.altText || p.title;
            img.loading = 'lazy';
            img.width = 100;
            img.height = 100;
            img.style.objectFit = 'cover';
            img.style.borderRadius = '4px';
            aImg.appendChild(img);
            flexDiv.appendChild(aImg);
          }
    
          const infoDiv = document.createElement('div');
          infoDiv.className = 'grid gap-1';
          infoDiv.style.flex = '1';
    
          const pTitle = document.createElement('p');
          pTitle.className = 'block m-0';
          const aTitle = document.createElement('a');
          aTitle.href = `/products/${p.handle}`;
          aTitle.className = 'reversed-link text-pcard-title fuzzy-result-link';
          aTitle.textContent = p.title;
          pTitle.appendChild(aTitle);
          infoDiv.appendChild(pTitle);
    
          if (p.priceRange && p.priceRange.minVariantPrice) {
            const priceDiv = document.createElement('div');
            priceDiv.className = 'text-price';
            const minPrice = parseFloat(p.priceRange.minVariantPrice.amount);
            const maxPrice = parseFloat(p.priceRange.maxVariantPrice.amount);
            const currencyCode = p.priceRange.minVariantPrice.currencyCode;
            let formattedPrice = '';
            
            if (minPrice === maxPrice) {
              formattedPrice = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(minPrice);
            } else {
              const formattedMin = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(minPrice);
              const formattedMax = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(maxPrice);
              formattedPrice = `${formattedMin} - ${formattedMax}`;
            }
            
            priceDiv.textContent = formattedPrice;
            infoDiv.appendChild(priceDiv);
          }
    
          flexDiv.appendChild(infoDiv);
    
          li.appendChild(flexDiv);
          list.appendChild(li);
        });
        
        container.appendChild(list);
      }

      if (collections.length > 0 || pages.length > 0) {
        const collectionsPagesWrapper = document.createElement('div');
        collectionsPagesWrapper.className = 'collections-pages-wrapper';


        if (pages.length > 0) {
          const pagesSection = document.createElement('div');
          pagesSection.className = 'predictive-search-result search__box-item predictive-search-result--pages';
          
          const heading = document.createElement('h4');
          heading.className = 'h5 predictive-search-result__heading';
          heading.textContent = `Pages (${pages.length})`;
          pagesSection.appendChild(heading);
          
          const list = document.createElement('ul');
          list.className = 'predictive-search-result__list';
          
          pages.forEach((page, idx) => {
            const li = document.createElement('li');
            li.id = `predictive-fuzzy-result-page-${idx+1}`;
            li.className = 'predictive-search__list-item';
            li.setAttribute('role', 'option');
            
            const a = document.createElement('a');
            a.href = `/pages/${page.handle}`;
            a.className = 'reversed-link fuzzy-result-link';
            a.textContent = page.title;
            li.appendChild(a);
            list.appendChild(li);
          });
          
          pagesSection.appendChild(list);
          collectionsPagesWrapper.appendChild(pagesSection);
        }

        const maybeYouMeantContainer = this.searchContent?.querySelector('#maybe-you-meant-placeholder');
        if (maybeYouMeantContainer) {
          collectionsPagesWrapper.appendChild(maybeYouMeantContainer);
        }

        if (collections.length > 0 || pages.length > 0 || maybeYouMeantContainer) {
          container.appendChild(collectionsPagesWrapper);
        }
      }
      
      setTimeout(() => {
        this.highlightFuzzyMatches();
      }, 100);
      this.delegateAddToCartButtons();
    }
  
    highlightFuzzyMatches() {
      const query = this.getQuery();
      if (!query || !this.searchContent) return;
      
      const container = document.getElementById('predictive-fuzzy-results');
      if (!container) return;
      
      const normalizedQuery = this.normalizeGreekText(query);
      const queryWords = normalizedQuery.split(/\s+/).filter(word => word.length > 2);
      if (queryWords.length === 0) return;
      
      const escapedWords = queryWords.map(word => word.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
      const regex = new RegExp(`\\b(${escapedWords.join('|')})\\b`, 'gi');
      
      const highlightElement = (element) => {
        if (!element || element.querySelector('strong')) return;
        
        const walker = document.createTreeWalker(
          element,
          NodeFilter.SHOW_TEXT,
          null,
          false
        );
        
        const textNodes = [];
        let node;
        while (node = walker.nextNode()) {
          if (node.textContent.trim()) {
            textNodes.push(node);
          }
        }
        
        textNodes.forEach(textNode => {
          const replaced = textNode.textContent.replace(regex, '<strong>$1</strong>');
          if (replaced !== textNode.textContent) {
            const span = document.createElement('span');
            span.innerHTML = replaced;
            textNode.parentNode.replaceChild(span, textNode);
          }
        });
      };
      
      container.querySelectorAll('.fuzzy-result-link, .text-pcard-title, .reversed-link').forEach(link => {
        highlightElement(link);
      });
      
      const maybeYouMeantContainer = this.searchContent?.querySelector('#maybe-you-meant-placeholder');
      if (maybeYouMeantContainer) {
        maybeYouMeantContainer.querySelectorAll('.maybe-you-meant-link, span').forEach(element => {
          highlightElement(element);
        });
      }
    }
  
    async fetchAllProducts(cursor = null) {
      const allProducts = [];
      let hasNextPage = true;
      let currentCursor = cursor;
      
      while (hasNextPage) {
        const graphqlQuery = {
          query: `
            query searchResults($cursor: String) {
              products(first: 250, after: $cursor) {
                pageInfo {
                  hasNextPage
                  endCursor
                }
                edges {
                  node {
                    id
                    title
                    handle
                    vendor
                    tags
                    featuredImage {
                      url
                      altText
                    }
                    priceRange {
                      minVariantPrice {
                        amount
                        currencyCode
                      }
                      maxVariantPrice {
                        amount
                        currencyCode
                      }
                    }
                    variants(first: 250) {
                      edges {
                        node {
                          id
                          availableForSale
                          price {
                            amount
                            currencyCode
                          }
                          compareAtPrice {
                            amount
                            currencyCode
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
          variables: currentCursor ? { cursor: currentCursor } : {}
        };
        
        try {
          const res = await fetch("/api/2025-10/graphql.json", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": "c6d9974d72d77faac424c49c22f624c8"
            },
            body: JSON.stringify(graphqlQuery)
          });
          const json = await res.json();
          const products = json?.data?.products?.edges?.map(e => e.node) || [];
          allProducts.push(...products);
          
          hasNextPage = json?.data?.products?.pageInfo?.hasNextPage || false;
          currentCursor = json?.data?.products?.pageInfo?.endCursor || null;
        } catch (err) {
          console.error("Failed to fetch products page:", err);
          break;
        }
      }
      
      return allProducts;
    }

    async fetchAllCollections(cursor = null) {
      const allCollections = [];
      let hasNextPage = true;
      let currentCursor = cursor;
      
      while (hasNextPage) {
        const graphqlQuery = {
          query: `
            query searchCollections($cursor: String) {
              collections(first: 250, after: $cursor) {
                pageInfo {
                  hasNextPage
                  endCursor
                }
                edges {
                  node {
                    id
                    title
                    handle
                    description
                    image {
                      url
                      altText
                    }
                    products(first: 10) {
                      edges {
                        node {
                          tags
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
          variables: currentCursor ? { cursor: currentCursor } : {}
        };
        
        try {
          const res = await fetch("/api/2025-10/graphql.json", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": "c6d9974d72d77faac424c49c22f624c8"
            },
            body: JSON.stringify(graphqlQuery)
          });
          const json = await res.json();
          const collections = json?.data?.collections?.edges?.map(e => e.node) || [];
          allCollections.push(...collections);
          
          hasNextPage = json?.data?.collections?.pageInfo?.hasNextPage || false;
          currentCursor = json?.data?.collections?.pageInfo?.endCursor || null;
        } catch (err) {
          console.error("Failed to fetch collections page:", err);
          break;
        }
      }
      
      return allCollections;
    }

    async fetchAndShowFuzzyResults(query) {
      if (query.length < 1) {
        const container = document.getElementById('predictive-fuzzy-results');
        if (container) {
          container.innerHTML = '';
          container.style.display = 'none';
          container.style.visibility = 'hidden';
          container.style.opacity = '0';
        }
        const fuzzyHeading = document.querySelector('.predictive-search-result__heading');
        if (fuzzyHeading) {
          fuzzyHeading.remove();
        }
        this.hideFuzzyLoader();
        return;
      }
  
      this.showFuzzyLoader();
      
      try {
        const allProducts = await this.fetchAllProducts();
        const collections = await this.fetchAllCollections();
        
        const filteredProducts = allProducts.filter(product => {
          if (!product.variants || !product.variants.edges || product.variants.edges.length === 0) {
            return false;
          }
          const variants = product.variants.edges.map(e => e.node);
          return variants.some(v => v.availableForSale);
        });
        
        const productResults = this.fuzzySearchTagFirst(filteredProducts, query, "title").slice(0, 15);
        const collectionResults = this.fuzzySearch(collections, query, "title");
        
        console.log('Fuzzy results found - Products:', productResults.length, 'Collections:', collectionResults.length);
        
        this.displayAllFuzzyResults(productResults, collectionResults, []);
        
        this.hideFuzzyLoader();
      } catch (err) {
        console.error("Failed fuzzy results fetch:", err);
        this.hideFuzzyLoader();
      }
    }
  
    showFuzzyLoader() {
      let loader = document.querySelector('.fuzzy-loader');
      if (!loader) {
        loader = document.createElement('div');
        loader.className = 'fuzzy-loader';
        loader.style.cssText = `
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 99999;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 40px;
          border-radius: 8px;
        `;
        loader.innerHTML = `
          <div class="loading__spinner">
            <svg aria-hidden="true" focusable="false" class="spinner icon icon--medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30" stroke="#000"></circle>
            </svg>
          </div>
        `;
        document.body.appendChild(loader);
        
        if (!document.querySelector('#fuzzy-loader-style')) {
          const style = document.createElement('style');
          style.id = 'fuzzy-loader-style';
          style.textContent = `
            .fuzzy-loader .spinner {
              animation: fuzzyRotate 2s linear infinite;
            }
            .fuzzy-loader .path {
              stroke-dasharray: 90, 150;
              stroke-dashoffset: 0;
              stroke-linecap: round;
              animation: fuzzyDash 1.5s ease-in-out infinite;
            }
            @keyframes fuzzyRotate {
              100% { transform: rotate(360deg); }
            }
            @keyframes fuzzyDash {
              0% {
                stroke-dasharray: 1, 150;
                stroke-dashoffset: 0;
              }
              50% {
                stroke-dasharray: 90, 150;
                stroke-dashoffset: -35;
              }
              100% {
                stroke-dasharray: 90, 150;
                stroke-dashoffset: -124;
              }
            }
          `;
          document.head.appendChild(style);
        }
      } else {
        loader.style.display = 'flex';
      }
    }
  
    hideFuzzyLoader() {
      const loader = document.querySelector('.fuzzy-loader');
      if (loader) {
        loader.remove();
      }
    }
  
    // Add calculateProductScore method to SearchDrawer class
    calculateProductScore(product, query) {
      const queryNormalized = this.normalizeGreekText(query);
      const queryWords = queryNormalized.split(/\s+/).filter(word => word.length > 0);
      const textNormalized = this.normalizeGreekText(product.title);
      
      const calculateFieldScore = (text, isTag = false) => {
        if (!text) return 0;
        const normalized = this.normalizeGreekText(text);
        let score = 0;
        let exactMatchBonus = 0;
        let wordMatchBonus = 0;
        let consecutiveMatchBonus = 0;
        let startMatchBonus = 0;
        let minimumMatchBonus = 0;
        
        let hasMinimumMatch = false;
        for (let i = 0; i <= normalized.length - 3; i++) {
          const substring = normalized.substring(i, i + 3);
          if (queryNormalized.includes(substring)) {
            hasMinimumMatch = true;
            minimumMatchBonus = 5;
            break;
          }
        }
        
        if (normalized.includes(queryNormalized)) {
          exactMatchBonus = isTag ? 20 : 25;
        }
        
        let matchedWords = 0;
        for (const word of queryWords) {
          if (normalized.includes(word)) {
            matchedWords++;
            wordMatchBonus += isTag ? Math.max(5, word.length * 1.2) : Math.max(6, word.length * 1.5);
          }
        }
        
        if (matchedWords > 1) {
          wordMatchBonus += matchedWords * (isTag ? 1.5 : 2);
        }
        
        const queryChars = queryNormalized.split('');
        let consecutiveCount = 0;
        let maxConsecutive = 0;
        let queryIndex = 0;
        
        for (let i = 0; i < normalized.length && queryIndex < queryChars.length; i++) {
          if (normalized[i] === queryChars[queryIndex]) {
            consecutiveCount++;
            queryIndex++;
          } else {
            if (consecutiveCount > maxConsecutive) {
              maxConsecutive = consecutiveCount;
            }
            consecutiveCount = 0;
          }
        }
        
        if (consecutiveCount > maxConsecutive) {
          maxConsecutive = consecutiveCount;
        }
        
        consecutiveMatchBonus = maxConsecutive / queryChars.length * (isTag ? 6 : 8);
        
        if (normalized.startsWith(queryNormalized)) {
          startMatchBonus = isTag ? 12 : 15;
        }
        
        score = exactMatchBonus + wordMatchBonus + consecutiveMatchBonus + startMatchBonus + minimumMatchBonus;
        
        if (!isTag) {
          const lengthBonus = Math.max(0, (50 - normalized.length) / 50);
          score += lengthBonus;
        }
        
        if (matchedWords > 1) {
          score += matchedWords * (isTag ? 2 : 3);
        }
        
        if (queryNormalized.length > 10 && matchedWords > 0) {
          score += isTag ? 3 : 5;
        }
        
        return score;
      };
      
      const titleScore = calculateFieldScore(product.title, false);
      
      let tagsScore = 0;
      if (product.tags && Array.isArray(product.tags) && product.tags.length > 0) {
        const tagsText = product.tags.join(' ');
        tagsScore = calculateFieldScore(tagsText, true);
      }
      
      return titleScore + tagsScore;
    }
  
    // Add calculateGreekSimilarity method to SearchDrawer class - UNIQUE IDENTIFIER
  
    // Add calculateExactMatchPercentage method to SearchDrawer class
    calculateExactMatchPercentage(query, title) {
      if (!query || !title) return 0;
      
      const queryWords = query.split(/\s+/).filter(word => word.length > 2);
      const titleWords = title.split(/\s+/).filter(word => word.length > 2);
      
      if (queryWords.length === 0 || titleWords.length === 0) return 0;
      
      let exactWordMatches = 0;
      let partialMatches = 0;
      
      for (const queryWord of queryWords) {
        // Check for exact word matches
        if (titleWords.includes(queryWord)) {
          exactWordMatches++;
        }
        // Check for partial matches (word contains query word or vice versa)
        else if (titleWords.some(titleWord => 
          titleWord.includes(queryWord) || queryWord.includes(titleWord)
        )) {
          partialMatches++;
        }
      }
      
      // Calculate percentage: exact matches get full weight, partial matches get half weight
      const totalScore = exactWordMatches + (partialMatches * 0.5);
      return totalScore / queryWords.length;
    }
  
    // Add hasMeaningMatch method to SearchDrawer class
    hasMeaningMatch(query, title) {
      if (!query || !title) return false;
      
      const greekMeanings = {
        'rustic': ['rustic'],
        'modern': ['modern'],
        'vintage': ['vintage'],
        'boho': ['boho', 'bohemian']
      };
      
      const queryWords = query.split(/\s+/).filter(word => word.length > 2);
      const titleWords = title.split(/\s+/).filter(word => word.length > 2);
      
      let meaningMatches = 0;
      
      for (const queryWord of queryWords) {
     
          for (const [key, meanings] of Object.entries(greekMeanings)) {
            if (meanings.includes(queryWord)) {
              if (titleWords.includes(key)) {
                meaningMatches++;
                break;
              }
            }
          }
      }
      
      // Return true if at least 2 meaning matches found
      return meaningMatches >= 2;
    }
  }
  customElements.define('search-drawer', SearchDrawer);